/* BTOCSITE-40437 PLP 스크립트 start */
$(document).ready(function(){
//[BTOCSITE-55908] [PLP] 전체 메뉴 개편 및 위치 개선
	/*
		개발에 요청
		1. PC 카테고리 탭 그림자 효과 제거
		<div class="cate-wrap ui_sticky fixed"> <-- fixed 제거

		헬로우바 테스트 코드
		$('header.header').addClass('helloBar');
		$('.subRenewWrap').addClass('hellobar-wrap');
		$('.hello-bar-wrap.hello-app').show();
	*/
	//퍼블페이지에서 헬로우바 1개 방지
	if(location.host.indexOf('wwwdev50') > -1 && $('.hello-bar-wrap').length >=2){
		$('.hello-bar-wrap').eq(1).hide();
	}
	var $header = $('header.header');
	var $mobileNavWrap = $('.mobile-nav-wrap.plp-renew');
	var $tab5 = $('.cate-m-tab');
	var $filter5 = $('.cate-m-filter>div');
	var $filter5Inner = $('.cate-m-filter .cate-wrap');
	var $tab5Inner = $('.cate-m-tab .cate-wrap');
	var $baseCate = $('.base-cate');
	var isScroll = true;
	
	$('head').append('<style>.subRenewWrap .header.no-hide, .no-transition{ transition: none !important;}</style>')
	$tab5Inner.find('.tabs input').on('change',function(){
		isScroll = false;
		setTimeout(function(){
			isScroll = true;
		},300)
		$tab5Inner.removeClass('absolute')
	})
	$(window).trigger('scroll')
	
    //라인업 모델 있을때 ( ?lineupId= ) 예외처리(상단 비주얼 공간 생김, bg깨짐 수정)
    if(location.href.indexOf('?lineupId=') > -1 && $tab5Inner.find('.cate-list').css('display') == 'none' ){
        $tab5Inner.parent().hide();
		$(window).on('resizeend',function(){
			$('.plp-new-main-banner-tab .main-banner-tab-background.resize-w img').css('height','100%')
		}).trigger('resize');
    }

	//카테고리탭 없을때 예외처리
	if($tab5Inner.children().length==0){
		$tab5.css('margin-top','-54px');
	}
	$(window).on('scroll',function(){
		if(isScroll == false){ return; }
		if(window.innerWidth >= 768 ){ return; }
		$filter5Inner = $('.cate-m-filter .cate-wrap');
		if( $filter5Inner.length == 0 || $filter5Inner == null){ return; }
		var tabH = 0;
		var tabTop = 0;
		if( $tab5Inner.hasClass('is-scroll-up') ){
			tabH = $tab5Inner.height();
			tabTop = $header.height()
		}else if($tab5.hasClass('expanded') && $tab5Inner.hasClass('is-scroll-down') ){
			tabH = $tab5Inner.height();
		}
		if($header.hasClass('hide') && $filter5Inner.hasClass('no-transition')){
			tabH = 0;
			tabTop = 0;
		}
		//MO 카테고리탭 : 헬로바 높이값 + 헤더 높이값 + 카테고리탭 높이값
        //노트북/태블릿 예외처리
		if( !getIsNotebook() ){
    		if($filter5.offset().top <= $(window).scrollTop()){
                if($filter5Inner.hasClass('fix')){
                    $filter5Inner.addClass('fix').css('top',tabH+tabTop)
                    if(tabH+tabTop == 0){
                        $tab5Inner.addClass('is-scroll-down');
                    }
                }else{
                    $filter5Inner.addClass('fix').css('top',0)
                    $tab5Inner.addClass('is-scroll-down');
                }
    		}else{
    			$filter5Inner.removeClass('fix');
    		}
        }
		//MO 헤더 : 헤더 무반응 구간 설정
		if($baseCate.offset().top < $(window).scrollTop()){
			$header.removeClass('no-hide');
			$mobileNavWrap.removeClass('no-hide').removeClass('no-transition');
			$tab5Inner.removeClass('no-hide').removeClass('no-transition');
		}else{
			$header.addClass('no-hide');
			$mobileNavWrap.addClass('no-transition').addClass('no-hide');
			$tab5Inner.addClass('no-transition').addClass('no-hide');
		}
		
		// if( 0 <= $(window).scrollTop() && $tab5.offset().top + 50 >= $(window).scrollTop() ){
		// 	$header.addClass('no-hide');
		// 	$mobileNavWrap.addClass('no-transition').addClass('no-hide');
		// 	$tab5Inner.addClass('no-transition').addClass('no-hide');
		// }else{
		// 	$header.removeClass('no-hide');
		// 	$mobileNavWrap.removeClass('no-hide').removeClass('no-transition');
		// 	$tab5Inner.removeClass('no-hide').removeClass('no-transition');
		// }
		
		//IOS 스크롤 바운스시 예외처리
		if(0 >= $(window).scrollTop()){
			$tab5Inner.addClass('absolute');
		}else{
			$tab5Inner.removeClass('absolute');
		}
	}).on('resizestart',function(){
		window.preInnerWidth = window.innerWidth;
	}).on('resizeend',function(){
		if(window.preInnerWidth == window.innerWidth){
			return;
		}
		//필터(PC,MO) 원소스 멀티유즈 분기설정
		if(window.innerWidth < 768){
			$baseCate.addClass('cate-m-filter');
			$filter5 = $('.cate-m-filter>div');
			$filter5Inner = $('.cate-m-filter .cate-wrap');
			$baseCate.find('.cate-wrap').removeClass('ui_sticky');
			if($baseCate.find('.cate-wrap').attr('ui-modules') == "Sticky"){
				$baseCate.find('.cate-wrap').vcSticky('destroy');
			}
			getIsNotebook() == false && $filter5.css('height',$filter5.height());
		}else{
			$baseCate.removeClass('cate-m-filter');
			$filter5 = null;
			$filter5Inner = null;
			$baseCate.find('.cate-wrap').addClass('ui_sticky');
			if($baseCate.find('.cate-wrap').attr('ui-modules') != "Sticky"){
				$baseCate.find('.cate-wrap').vcSticky();
			}
		}
		//카테고리 탭 확장 닫기
		if( $('.cate-m.is-plp-new.mo-only').hasClass('expanded') ){
			$('.cate-m.is-plp-new.mo-only').find('.btn-expand').trigger('click')
		}
		if( $('.cate-m.is-plp-new.base-cate').hasClass('expanded') ){
			$('.cate-m.is-plp-new.base-cate').find('.btn-expand').trigger('click')
		}

		setTimeout(function(){
			var baseH = $baseCate.children().children().height();
			getIsNotebook() == false && $baseCate.children().css('height',baseH);
			cabinetSlideBtnHide2();
			$tab5Inner.css('visibility','visible');
		})
	}).on('catetabchange',function(e,data){
		//카테고리탭 클릭
		$('html, body').clearQueue().stop();
		//카테고리탭 열린상태이면 닫기
		if($tab5.hasClass('expanded')){
			$tab5.removeClass('expanded');
		}
		$('[data-sub-category-id="'+data+'"]').prop('checked',true);
		var tabH = $tab5Inner.height();
		var tabTop = $header.height();
		var scrollTop = 0;
		if(window.innerWidth < 768){
			scrollTop = $filter5.offset().top  - (tabH + tabTop);
		}else{
			scrollTop = $baseCate.offset().top
		}
		//연속으로 클릭시 덜컹거림 방지
		if( Number(scrollTop.toFixed()) == $(window).scrollTop() ){
			return;
		}
		isScroll=false;
		$('html, body').animate({scrollTop : scrollTop}, 300, function(){
			if ($(this).is('html')) return; // html, body 2중 호출 방지
			setTimeout(function(){
				if(window.innerWidth < 768){
					$(window).trigger('scroll');
					$header.clearQueue().stop().removeClass('hide');
					$mobileNavWrap.clearQueue().stop().removeClass('hide');
					$tab5Inner.addClass('is-scroll-up').removeClass('is-scroll-down');
					initCateSmoothScroll($tab5);
				}
				$(window).trigger('scroll');
				isScroll=true;
			},100);
		});
	}).on('catetabopen',function(){
		//MO 카테고리탭 열기시
		if(window.innerWidth < 768){
			$(window).trigger('scroll');
		}
	}).on('catetabclose',function(){
		//MO 카테고리탭 닫기시
		if(window.innerWidth < 768){
			var isDown = $tab5Inner.hasClass('is-scroll-down');
			$filter5Inner.addClass('no-transition');
			$(window).trigger('scroll');
			$filter5Inner.removeClass('no-transition');
			if(isDown){
				$tab5Inner.removeClass('is-scroll-up').addClass('is-scroll-down');
			}
		}
	}).trigger('resizeend');

	setTimeout(function(){
		//초기화 카테고리탭 좌우 메뉴 활성화 위치로 가기 
		cateActIntoView($tab5);
		cateActIntoView($baseCate);

		//케어용품/소모품 > 카테고리탭간 이동시 카테고리탭 top 위치로
		if(sessionStorage.getItem('isPrevPlpClick') == 'true' ){
			$(window).trigger('catetabchange',$('.cate-m input:checked').attr('sub-category-id'));
			setTimeout(function(){
				if(window.innerWidth < 768){
					$header.clearQueue().stop().removeClass('hide');
					$mobileNavWrap.clearQueue().stop().removeClass('hide');
					$tab5Inner.addClass('is-scroll-up').removeClass('is-scroll-down');
				}
			},500);
		}
		sessionStorage.setItem('isPrevPlpClick', 'false');
	});
	
	//헤더 햄버거 메뉴
	// $('.plp-renew .mobile-nav-button').on('click',function(){
	// 	$('.mobile-status-list .list-item.nav-anchor a').trigger('click');
	// });
	//카테고리 탭 아코디언 버튼 노출, 비노출
	function cabinetSlideBtnHide2() {
		$('.plp-new .fixed-tab-wrap .ui_smooth_tab .tabs').each(function(){
			var thumbList = $(this);
			if( thumbList.length == 0 ){return;}
			var thumbListWrap = thumbList.parent();
			if(thumbList.width() > thumbListWrap.width()) {
				thumbListWrap.parents('.cate-list').find(".btn-expand").show();
			} else if(thumbList.width() < thumbListWrap.width()) {
			  thumbListWrap.parents('.cate-list').find(".btn-expand").hide();
			}
		})
	}
	function getIsNotebook(){
		//노트북/태블릿 구분 변수
		var _isNotebook = false;
	    if(location.href.indexOf('.kr/notebook') > -1){
	        _isNotebook = true;
	    }
	    if($('.plp-afilter-choice .plp-afilter-inner .afilter-btn-area').length==1){
	        //노트북/태블릿 > VIEW, 노트북 세트는 일반 PLP 와 같음
	        _isNotebook = false;
	    }	
		return _isNotebook;
	}
	
	var isSetNotebookSticky = false;
	$(function(){
		//노트북/태블릿 일때 무조건 한번 호출
		if(location.href.indexOf('.kr/notebook') > -1){
			//노트북/태블릿 옵션탭, 필터탭, 스티키 예외처리
			var $noteFilter
			var $noteFilterParent 
			var $noteTab
			var $noteFilterOpt 
			var $noteFilterOptParent

			if($('.product-list-top-wrap').length == 0){
				$noteFilter = $('.product-list-top');
				$noteFilter.wrap('<div>').wrap('<div class="product-list-top-wrap">');
				$noteFilter = $('.product-list-top-wrap');
				$noteFilterParent = $noteFilter.parent();
				$noteTab = $('.cate-m-tab .cate-wrap')
				$noteFilterOpt = $('.laptap-opt-list-wrap').eq(0);
				$noteFilterOpt.wrap('<div>');
				$noteFilterOptParent = $noteFilterOpt.parent();
			}else{
				$noteFilter = $('.product-list-top');
				$noteFilter = $('.product-list-top-wrap');
				$noteFilterParent = $noteFilter.parent();
				$noteTab = $('.cate-m-tab .cate-wrap')
				$noteFilterOpt = $('.laptap-opt-list-wrap').eq(0);
				$noteFilterOptParent = $noteFilterOpt.parent();	
			}
			
			if(isSetNotebookSticky === false){
				isSetNotebookSticky = true;
				$(window).on('scroll',function(){
					if(window.innerWidth < 768){
						if( !getIsNotebook() ){ 
							$('.cate-m-filter>div').css('height','44px');
							$noteFilterParent.css('height', 'auto');
							$noteFilter.removeClass('fix');
							$noteFilterOptParent.css('height', 'auto');
							$noteFilterOpt.removeClass('fix');
							$noteFilterOpt.css('top',0)
							$noteFilter.css('top',0)
							return;
						}
						$('.cate-m-filter>div').css('height','auto')

						if($filter5Inner.hasClass('fix')){
							$filter5Inner.removeClass('fix');
						}
						
						var optH = $noteFilterOpt.outerHeight();
						if($noteFilterOpt.outerHeight() < 20 ){
							optH = 0;
						}
						//옵션탭, 필터탭 스티키 여부
						if($(window).scrollTop()> $noteFilterParent.offset().top){
							$noteFilterParent.css('height', $noteFilter.outerHeight());
							$noteFilter.addClass('fix');
							
							$noteFilterOptParent.css('height', optH);
							$noteFilterOpt.addClass('fix');
						}else{
							$noteFilterParent.css('height', 'auto');
							$noteFilter.removeClass('fix');
			
							$noteFilterOptParent.css('height', 'auto');
							$noteFilterOpt.removeClass('fix');
						}
						
						//옵션탭, 필터탭 스티키시 TOP 위치 잡기
						if($noteFilter.hasClass('fix')){
							if( $noteTab.hasClass('is-scroll-up') ){
								var noteTabTop = ($('.hellobar-wrap').length > 0 ? 88:46) + $noteTab.outerHeight()
								$noteFilterOpt.css('top',noteTabTop)
								$noteFilter.css('top',noteTabTop + optH)
							}else{
								var tabOpenH = 0
								if($noteTab.closest('.cate-m-tab').hasClass('expanded')){
									tabOpenH = $noteTab.outerHeight()
								}
								console.log( $noteFilterOpt.outerHeight())
								$noteFilterOpt.css('top',tabOpenH)
								$noteFilter.css('top',optH + tabOpenH)
							}
						}else{
							$noteFilterOpt.css('top',0)
							$noteFilter.css('top',0)
						}	
					}
				}).on('resizeend',function(){
					if(window.innerWidth < 768){
						$('body').addClass('notebook')
					}else{
						$noteFilterParent.css('height', 'auto');
						$noteFilter.removeClass('fix');
						$noteFilterOptParent.css('height', 'auto');
						$noteFilterOpt.removeClass('fix');
						$noteFilterOpt.css('top',0)
						$noteFilter.css('top',0)
						$('body').removeClass('notebook')
					}
				}).on('catetabchange',function(e,data){
					if(window.innerWidth < 768){
						if( !getIsNotebook() ){ 
							$('.cate-m-filter>div').css('height','44px')
							$noteFilterParent.css('height', 'auto');
							$noteFilter.removeClass('fix');
							$noteFilterOptParent.css('height', 'auto');
							$noteFilterOpt.removeClass('fix');
							$noteFilterOpt.css('top',0)
							$noteFilter.css('top',0)
						}else{
							$('.cate-m-filter>div').css('height','auto')
						}
						setTimeout(function(){
							if( getIsNotebook() ){ 
								$('.cate-m-filter>div').css('height','auto')
							}
						},1000)
					}
				}).on('catetabclose',function(){
					//MO 카테고리탭 닫기시
					if(window.innerWidth < 768){
						$(window).scrollTop($(window).scrollTop()+1);
					}
				}).on('load',function(){
					$(window).trigger('catetabclose')
				}).trigger('resizeend').trigger('scroll');
			}else{
				$(window).trigger('resizeend').trigger('scroll');
			}
		}
	}());
////[BTOCSITE-55908] [PLP] 전체 메뉴 개편 및 위치 개선

	var $section = $('.component.KRP0007');
	var $unitList = $section.find('.product-card-list');

	const KR_TIME_DIFF = 9 * 60 * 60 * 1000;
	const _SECOND	= 1000;
	const _MINUTE	= _SECOND * 60;
	const _HOUR	= _MINUTE * 60;
	const _DAY	= _HOUR * 24;

	// PLP PC버전 header 보정 start
	if($('.container .plp-new')) {
		if($('.mobile-nav-wrap.is-depth')) {
			if (window.innerWidth > 1024) {
				$('body > div.wrap').removeClass('is-plp-new-m').addClass('is-plp-new');
			}
			else {
				$('body > div.wrap').removeClass('is-plp-new').addClass('is-plp-new-m');
			}
			$(window).resize(function(){
				if (window.innerWidth > 1024) {
					$('body > div.wrap').removeClass('is-plp-new-m').addClass('is-plp-new');
				}
				else {
					$('body > div.wrap').removeClass('is-plp-new').addClass('is-plp-new-m');
				}
			});
		}
	}
	if($('.iw_container .plp-new')) {
		if($('.mobile-nav-wrap.is-depth')) {
			if (window.innerWidth > 1024) {
				$('body .iw_section.plp').removeClass('is-plp-new-m').addClass('is-plp-new');
			}
			else {
				$('body .iw_section.plp').removeClass('is-plp-new-m').addClass('is-plp-new');
			}
			$(window).resize(function(){
				if (window.innerWidth > 1024) {
					$('body .iw_section.plp').removeClass('is-plp-new-m').addClass('is-plp-new');
				}
				else {
					$('body .iw_section.plp').removeClass('is-plp-new-m').addClass('is-plp-new');
				}
			});
		}
	}
	// PLP PC버전 header 보정 end

	// BTOCSITE-50864 Hello Bar 임직원몰 헬로우바 중복 방지
	function headerSet() {
		try {
			$('.hello-bar-wrap.emp-hello').hide(); // 임직원몰 hello bar 메인만 노출

			if (lgkorUI.getHiddenInputData().helloBarFlag == "Y" && lgkorUI.getHiddenInputData().bizType == "PRODUCT"
				&& lgkorUI.getCookie("helloBar") != 'Y' && $('header.header').attr('data-hellobar') != 'helloEmp') {
				lgkorUI.showHelloBar(true);
			}
		} catch (e) { console.log("KRP007 header Error:" + e); }
	}
	headerSet();

	// PLP 필터 툹팁 on/off 이벤트 start
	$(window).scroll(function(){
		$(".tooltip-container").each(function(){
			var $this = $(this);
			var scrPosWin = $(window).scrollTop();
			var scrPos = $(this).parent().offset().top - 200;
			if(scrPosWin > scrPos) {
				setTimeout(function(){
					$this.removeClass('ani');
					setTimeout(function(){
						$this.removeClass('active');
					}, 700);
				}, 5000);
			}
		});
	});
	$(".lay-filter").scroll(function(){
		$(".lay-filter .tooltip-container").each(function(){
			var $this = $(this);
			var scrPosWin = $(window).scrollTop();
			var scrPosPcFilter = $(".lay-filter").offset().top - 300;
			var scrPosPcFilterInner = $(".lay-filter").offset().top;
			var scrPos = $(this).parent().offset().top - 120;
			if (window.innerWidth > 1024) {
				if(scrPosWin > scrPosPcFilter && scrPosPcFilterInner > scrPos) {
					setTimeout(function(){
						$this.removeClass('ani');
						setTimeout(function(){
							$this.removeClass('active').addClass('first-opened');
						}, 700);
					}, 5000);
				}
			}
		});
	});
	$(document).on('click', ".btn-afilter", function(){
		if(window.innerWidth < 1025) {
			$(".lay-filter .tooltip-container").each(function() {
				var $this = $(this);
				if($this.hasClass("first-opened") === false) {
					$this.addClass('ani').addClass('active').addClass('first-opened');
				}
			});
		}
	});

	$(document).on("click", '.tooltip-container .close', function() {
		$this = $(this);
		$this.parent().removeClass('ani');
		setTimeout(function(){
			$this.parent().removeClass('active');
		}, 700);
	});
	// PLP 필터 툹팁 on/off 이벤트 end

	var initOptionSwiper = function(selector) {
		var scopeSelector = selector === undefined ? "" : selector; // ssr 와 ajax res 에 .swiper-initialized 박혀 렌더링됨.. 때문에 일반 초기화와 특정 위치지정 초기화 구별 위해 추가 // BTOCSITE-60672
		// PLP 썸네일 input - text 타입 start
		if($('.prd-type-cont1 .swiper-slide').length) {
			try {
			var prdThumbSel1 = new Swiper(scopeSelector + " .prd-type-cont1", { // 특정 부모 swiper만 재설정 위해 scopeSelector 추가 // BTOCSITE-60672
				spaceBetween: 0,    // 슬라이드 사이 여백
				slidesPerView : 'auto', // 한 슬라이드에 보여줄 갯수
				centeredSlides: false,    //센터모드
					loop: false,   // 슬라이드 반복 여부
					loopAdditionalSlides: 1,
					observer: false,
					observeParents: true,
					navigation: {
						nextEl: '.item-middle-prdtype-arrow .right', // 다음 버튼 클래스명
						prevEl: '.item-middle-prdtype-arrow .left', // 이번 버튼 클래스명
					},
					on: {
						init: function (swiper) {
							// 초기화 후 체크된 .swiper-slide 을 itemCenter 적용 // BTOCSITE-60672 [PLP] 선택한 컬러칩으로 포커싱되지 않는 현상
							var $checkElm = $(swiper.el).find('input:checked~label').parent().eq(0);
							if ($checkElm.length > 0) itemCenter($checkElm, 0);
						}
					}
				});
			} catch(e) {
				console.log('new Swiper Error: ', e);
			}
			var prdItem = $(".prd-type-cont1").find('label');
			prdItem.each(function() {
				$(this).on('click', function() {
					var target = $(this).parent();
					itemCenter(target);
				});
			});
		}
		// PLP 썸네일 input - text 타입 end
		// PLP 썸네일 input - circle 타입 start
		if($('.prd-type-cont2 .swiper-slide').length) {
			try {
				var prdThumbSel2 = new Swiper(scopeSelector + " .prd-type-cont2", { // 특정 부모 swiper만 재설정 위해 scopeSelector 추가 // BTOCSITE-60672
					spaceBetween: 0,    // 슬라이드 사이 여백
					slidesPerView : 'auto', // 한 슬라이드에 보여줄 갯수
					centeredSlides: false,    //센터모드
					loop : false,   // 슬라이드 반복 여부
					loopAdditionalSlides : 1,
					observer: false,
					observeParents: true,
					navigation : {
						nextEl : '.item-middle-prdtype-arrow .right', // 다음 버튼 클래스명
						prevEl : '.item-middle-prdtype-arrow .left', // 이번 버튼 클래스명
					},
					on: {
						init: function (swiper) {
							// 초기화 후 체크된 .swiper-slide 을 itemCenter 적용 // BTOCSITE-60672 [PLP] 선택한 컬러칩으로 포커싱되지 않는 현상
							var $checkElm = $(swiper.el).find('input:checked~label').parent().eq(0);
							if ($checkElm.length > 0) itemCenter($checkElm, 0);
						}
					}
			});
			} catch(e) {
				console.log('new Swiper Error2: ', e);
			}
			var colorItem = $(".prd-type-cont2").find('label');
			colorItem.each(function() {
				$(this).on('click', function() {
					var target = $(this).parent();
					itemCenter(target);
				});
			});
		}
	}
	initOptionSwiper();
	// PLP 썸네일 input - circle 타입 end

	// PLP Swiper 중간정렬 start
	// PLP Swiper 중간정렬 start
	function itemCenter(target, speed){
		var swiperWrap = target.parent();
		var targetPos = target.position();
		var box = swiperWrap.parent();
		var boxHarf = box.outerWidth() / 2;
		var pos;
		var listWidth = 0;
		var duration = speed === undefined ? 500 : speed; // 빠른 이동위해 500ms 고정값이던걸 선택하도록 수정 // BTOCSITE-60672 [PLP] 선택한 컬러칩으로 포커싱되지 않는 현상

		swiperWrap.find('.swiper-slide').each(function(){
			listWidth += $(this).outerWidth();
		});
		var selectTargetPos = targetPos.left + target.outerWidth() / 2;

		if (selectTargetPos <= boxHarf) { // left
			pos = 0;
		} else if ((listWidth - selectTargetPos) <= boxHarf) { //right
			if(box.width() > listWidth) { // pc 에서 좌우 padding 화살표 영역을 쓰기때문에 outWidth() 에서 width() 로 변경하여 if 문 의도에 맞도록 수정 // BTOCSITE-60672
				// no scroll
				pos = 0;
			} else {
				// scroll
				pos = listWidth - box.width();
			}
		} else {
			pos = selectTargetPos- boxHarf;
		}

		var aniFn = function(){
			swiperWrap.css({
				"transform": "translate3d("+ (pos*-1) +"px, 0, 0)",
				"transition-duration": duration + "ms"
			});
		}

		if (duration === 0) { // duration === 0 즉, 옵션 변경에 의한 itemCenter() 호출은 swiper init 보증하기에 즉시 실행하여 늦게 위치 잡는 문제해결 // BTOCSITE-60672
			aniFn();
		} else {
			setTimeout(aniFn, 200);
		}
		
	}
	// PLP Swiper 중간정렬 end
	// PLP Swiper 중간정렬 end
	// PLP 제품 리스트 view 방식 변경 스크립트 start
	function resizeEvPlp2() {
		if (window.innerWidth > 768) {
			$(".change-target").each(function() {
				var mathWid2 = $(this).outerWidth();
				var resizingWid2 = $(this).find('img').outerWidth();
				var mathHei2 = $(this).outerHeight();
				var resizingHei2 = $(this).find('img').outerHeight();
				if (mathHei2 > resizingHei2) {
					$(this).removeClass('resize-w').addClass('resize-h');
				}
				if (mathHei2 < resizingHei2) {
					$(this).removeClass('resize-h').addClass('resize-w');
				}
				if (mathWid2 > resizingWid2) {
					$(this).removeClass('resize-h').addClass('resize-w');
				}
				if (mathWid2 < resizingWid2) {
					$(this).removeClass('resize-w').addClass('resize-h');
				}
			});
		}
	}
	resizeEvPlp2();
	$(window).resize(function(){
		resizeEvPlp2();
	});

	// PLP 제품 리스트 비교하기 버튼 토글 start
	/*$('.item-top-badge .comparison').click(function(){
		$(this).toggleClass('active');
		$(this).parent().parent().parent().find('.item-bottom').children('.item-bottom-button').children('.comparison').toggleClass('active');
	});*/
	var checkCompareClick = false;
	$unitList.on('click', '.comparison-content .comparison-content-button, .item-top-badge .item_compare .comparison', function(e) {
		e.preventDefault();
		// BTOCSITE-30428 : 빠른 클릭시 레이아웃이 안뜨는 형상 발생
		if(checkCompareClick) {
			return;
		}
		checkCompareClick = true;

		$(this).toggleClass('active');

		var modelId = $(this).data("model-id");
		var b2bCateMapping = $(this).data("b2b-cate-mapping");
		var defaultCategoryId = $(this).data("default-category-id");
		var defaultCategoryName = $(this).data("default-category-name");

		var careType = $(this).data("care-type");

		if ($(this).hasClass("active")) {
			// BTOCSITE-62469 [선감지][모니터링 G] PLP 화면에서 비교하기 선택 시 닷컴ONLY 뱃지 미노출 되는 현상 START
			var lgecomOnlyFlag = "";
			var b2cYN = "";
			if ($(this).parents('.card-list-item').find('.lge-only').length !== 0 || $(this).parents('.card-list-item').find('.badge-lge-only').length !== 0) { // BTOCSITE-73900 [모니터링 G][PC] 해당 상품의 "닷컴 ONLY" 기호는 상품 비교 양식에서 표시되지 않음
				lgecomOnlyFlag = "Y";
				b2cYN = "Y";
			}
			// BTOCSITE-62469 [선감지][모니터링 G] PLP 화면에서 비교하기 선택 시 닷컴ONLY 뱃지 미노출 되는 현상 END
			var $item = $(this).closest(".card-list-item");
			lgkorUI.addCompareProd(defaultCategoryId, {
				id: modelId,
				b2bcatemapping: b2bCateMapping,
				productName: $(this).data('model-display-name'),
				productID: $(this).data('model-name'),
				productImg: $item.find(".item-middle-thumb a img").attr("src"),
				productAlt: $(this).data('model-display-name'),
				careType: careType,
				path: $item.find(".item-middle-thumb a").attr("href"),
				// BTOCSITE-62469 [선감지][모니터링 G] PLP 화면에서 비교하기 선택 시 닷컴ONLY 뱃지 미노출 되는 현상 START
				lgecomOnlyFlag: lgecomOnlyFlag,
				b2cYN: b2cYN
				// BTOCSITE-62469 [선감지][모니터링 G] PLP 화면에서 비교하기 선택 시 닷컴ONLY 뱃지 미노출 되는 현상 END
			}, defaultCategoryName);

		} else {
			// BTOCSITE-62469 [선감지][모니터링 G] PLP 화면에서 비교하기 선택 시 닷컴ONLY 뱃지 미노출 되는 현상 START
			$('.sticy-compare .list-inner li').removeClass("lge-only"); 
			// BTOCSITE-62469 [선감지][모니터링 G] PLP 화면에서 비교하기 선택 시 닷컴ONLY 뱃지 미노출 되는 현상 END
			lgkorUI.removeCompareProd(defaultCategoryId, modelId);
		}

		//console.log('call initCompare click');
		initCompare();

		setTimeout(function() {
			checkCompareClick = false;
		}, 500);

		//$(this).parent().parent().parent().find('.item-top-badge').children('.top-badge-right').children('.comparison').toggleClass('active');
	});

	//위시리스트
	// $(document).on('click', '.wish-list .wish-list-button', function(e){
	// 	console.log('AAAAAAAAAAAAAAAAAAAAAAAA');
	// 	e.preventDefault();
	// 	//$(this).toggleClass('active');
	// });

	// 비교하기 레이어 변경시(trigger)에 처리
	$(window).on("changeStorageData.compare", function() {
		//console.log('call initCompare change');
		initCompare();
	});

	// 제폼 비교하기 레이어 초기화
	function initCompare() {
		var itemCompareBtn = $('.card-list-item').find('.comparison-content .comparison-content-button')[0];
		if (!$(itemCompareBtn).length || !$(itemCompareBtn).data('default-category-id')) {
			return;
		}

		var compareStorage = lgkorUI.getStorage(lgkorUI.COMPARE_KEY, $(itemCompareBtn).data('default-category-id'));

		if (!compareStorage || (compareStorage.constructor === Object && Object.keys(compareStorage).length === 0)) {
			$('.card-list-item').find('.comparison-content .comparison-content-button, .item-top-badge .item_compare .comparison').removeClass('active');
		} else {
			$('.card-list-item').find('.comparison-content .comparison-content-button, .item-top-badge .item_compare .comparison').each(function(idx, cmp) {
				if (compareStorage.data.filter(d => d.id === $(cmp).data('model-id')).length > 0) {
					if (!$(cmp).hasClass('active')) {
						$(cmp).addClass('active');
					}
				} else {
					$(cmp).removeClass('active');
				}
			});
		}
	}

	initCompare();
	// PLP 제품 리스트 비교하기 버튼 토글 end

	// PLP 제품 장바구니 클릭 start
	$unitList.on('click','button.cart',function(e){
		e.preventDefault();
		var $this = $(this);
		var bizType = $(this).data('biz-type');
		//var typeflag = $(this).attr('data-type-flag');
		var sendFlag = (bizType == "PRODUCT" || bizType == "DISPOSABLE") ? "P" : "C";

		var param = {
			"id": $this.data('model-id'),
			"sku": $this.data('sku'),
			"rtSeq": '',
			"typeFlag": sendFlag,
			"pageType": "plp"
		}
		var ajaxUrl = $section.data('cart-url');
		lgkorUI.requestCart(ajaxUrl, param, true);

	});
	// PLP 제품 장바구니 클릭 end

	// PLP 제품 리스트 총 갯수 표시 start
	function plpItemTotalCount() {
		var plpCountContent = $('.list-sorting .list-count em');
		var plpCountContentM = $('.list-count-mobile .count');
		var plpListItemCount = $('.card-list-item.normal-card').length;
		if(plpCountContent) {
			plpCountContent.text(plpListItemCount);
		}
		if(plpCountContent) {
			plpCountContentM.text(plpListItemCount);
		}
	}
	//plpItemTotalCount();
	// PLP 제품 리스트 총 갯수 표시 end

	/* BTOCSITE-49751 [상품] 딜 플랫폼 Start */
	function setTimeDeal() {
		const $timeDeal = $('div.item-timedeal');
		const $timedealTimeList = $timeDeal.find($('div.timedeal-time'));

		try {
			$timedealTimeList.each(function (){
				const timeDealEndDate = $(this).data('end-date');
				countDownTimer(new Date(timeDealEndDate), $(this));
			});
		} catch (e) {
			console.log(e);
		}
	}
	setTimeDeal();

	// 타이머
	function countDownTimer(targetDateTime, targetElement) {
		let timer;

		try {
			if (targetElement.parents('div.item-timedeal').hasClass('sold-out')) {
				targetElement.text("SOLD OUT");
				return;
			}

			function calculateRemainingTime() {
				const current = new Date();
				const utc = current.getTime() + (current.getTimezoneOffset() * _MINUTE);
				const currentKRDateTime = new Date(utc + (KR_TIME_DIFF));

				let remainingTime = targetDateTime - currentKRDateTime;

				if (remainingTime > _DAY) {
					let days = Math.floor(remainingTime / _DAY);
					targetElement.text("D-" + days);

					clearInterval(timer);
					return;
				} else {
					if (remainingTime <= 0) {
						clearInterval(timer);
					} else {
						let hours = Math.floor((remainingTime % _DAY) / _HOUR);
						let minutes = Math.floor((remainingTime % _HOUR) / _MINUTE);
						let seconds = Math.floor((remainingTime % _MINUTE) / _SECOND);

						hours = hours < 10 ? "0" + hours : hours;
						minutes = minutes < 10 ? "0" + minutes : minutes;
						seconds = seconds < 10 ? "0" + seconds : seconds;

						targetElement.text(hours + ":" + minutes + ":" + seconds);
					}
				}
			}

			timer = setInterval(calculateRemainingTime, 1000);
		} catch (e) {
			console.log(e);
		}
	}
	/* BTOCSITE-49751 [상품] 딜 플랫폼 End */


	// PLP 최대 혜택가 팝업 이벤트 start
	// BTOCSITE-61935, [PLP] 최대혜택가 안내 팝업 수정 - 디자인 수정
	$unitList.on('click', '.max-reward', function(e) {
		e.preventDefault();

		var viewType = $('.grid-change-cont button').hasClass('twin-type') ? 'twin-type' : 'list-type';
		if (viewType === 'twin-type' && vcui.detect.isMobileDevice && $(this).data('model-url')) {
			location.href = $(this).data('model-url');
			return false;
		}

		var $anchorEl = $(e.currentTarget).children('a');

		//판매중일때만 레이어 오픈
		var modelStatusCode = $anchorEl.data('model-status-code');
		if (modelStatusCode !== "ACTIVE" && modelStatusCode !== "SOLD_OUT") {
			return;
		}

		var rewardPrice = $anchorEl.data('reward-price') || '0';					// 최대 혜택가
		var originalPrice = $anchorEl.data('original-price') || '0';				// 판매가
		var sellingPrice = $anchorEl.data('selling-price') || '0';
		var memberDiscountPrice =  $anchorEl.data('member-discount-price') || '0';	// 회원할인
		var extraDiscountPrice =  $anchorEl.data('extra-discount-price') || '0';	// 추가할인
		var couponDiscountPrice = $anchorEl.data('coupon-discount-price') || '0';	// 쿠폰할인가
		var couponDiscountRate = $anchorEl.data('coupon-discount-rate') || '0';		// 쿠폰할인률
		var discountApprPrice = $anchorEl.data('discount-appr-price') || '0';		// 할인결제가

		var cardCashBackPrice = $anchorEl.data('card-cash-back-price') || '0';				// 캐시백(최대)
		var apprDateDiscountPrice = $anchorEl.data('appr-date-discount-price') || '0';		// 결제일 할인가
		var apprDateDiscountRate = $anchorEl.data('appr-date-discount-rate') || '0';		// 결제일 할인률
		
		var partnerPrice = $anchorEl.data('partner-price') || '0';		// 임직원/복지몰 가격, BTOCSITE-60019
		var empType = $anchorEl.data('emp-type') || '';					// 임직원/복지몰 구분, BTOCSITE-60019
		
		var hasDefaultDiscount = memberDiscountPrice !== '0' || extraDiscountPrice !== '0' || couponDiscountPrice !== '0';
		var hasAddDiscount = cardCashBackPrice !== '0' || apprDateDiscountPrice !== '0';

		var popupBody = $('#maximumBenefitPricePopup section.pop-body');

		var $first = popupBody.find('#firstMaximumBenefit');
		var $second = popupBody.find('#secondMaximumBenefit');
		var $third = popupBody.find('#thirdMaximumBenefit');

		if ($second.hasClass("last")) {
			$second.removeClass("last");
		}
		
		$first.hide();
		$second.hide();
		$third.hide();
		
		$first.find('ul.discount-price').remove();
		$second.find('ul.discount-price').remove();
		
		var firstLis = '';
		var secondLis = '';
		
		if ((empType === 'A' || empType === 'B') && partnerPrice !== '0') {
			// BTOCSITE-60019
			$first.show();
			$third.show();

			$('#maximumBenefitPricePopup header.pop-header h4.tit span').html(empType === 'A' ? '임직원 최대혜택가' : '복지몰 최대혜택가');

			$first.find('div.price span.txt').html(empType === 'A' ? '임직원 할인가' : '복지몰 할인가');
			$first.find('div.price span.won').html(vcui.number.addComma(partnerPrice) + '원');

			//s:BTOCSITE-64658 [개발] 임직원몰 / 계열사/ 복지몰 쿠폰 - 임직원 쿠폰 할인가 추가(20240610)
			if (couponDiscountPrice !== '0' && parseInt(partnerPrice)  >  parseInt(couponDiscountPrice) ) {
				$second.show();

				var partnerCouponDiscountPrice = parseInt(partnerPrice) - parseInt(couponDiscountPrice);

				firstLis += '<li><span class="txt">쿠폰 할인' + (couponDiscountRate !== '0' ? ' ' + couponDiscountRate + '%' : '') + '</span><span class="won">-' + vcui.number.addComma(couponDiscountPrice) + '원</li>';
				$second.find('div.price span.won').html(vcui.number.addComma(partnerCouponDiscountPrice) + '원');

				if (cardCashBackPrice !== '0') {
					secondLis += '<li><span class="txt">캐시백 (최대)</span><span class="won">-' + vcui.number.addComma(cardCashBackPrice) + '원</li>';
				}

				if (apprDateDiscountPrice !== '0') {
					secondLis += '<li><span class="txt">결제일 할인' + (apprDateDiscountRate !== '0' ? ' ' + apprDateDiscountRate + '% (최대)' : '') + '</span><span class="won">-' + vcui.number.addComma(apprDateDiscountPrice) + '원</li>';
				}

			}else{

				if (cardCashBackPrice !== '0') {
					firstLis += '<li><span class="txt">캐시백 (최대)</span><span class="won">-' + vcui.number.addComma(cardCashBackPrice) + '원</li>';
				}

				if (apprDateDiscountPrice !== '0') {
					firstLis += '<li><span class="txt">결제일 할인' + (apprDateDiscountRate !== '0' ? ' ' + apprDateDiscountRate + '% (최대)' : '') + '</span><span class="won">-' + vcui.number.addComma(apprDateDiscountPrice) + '원</li>';
				}
			}
			//e:BTOCSITE-64658 [개발] 임직원몰 / 계열사/ 복지몰 쿠폰 - 임직원 쿠폰 할인가 추가(20240610)

			if (firstLis !== '') {
				$first.append('<ul class="discount-price">' + firstLis + '</ul>');
			}

			if (secondLis !== '') {
				$second.append('<ul class="discount-price">' + secondLis + '</ul>');
			}

			$third.find('span.won').html(vcui.number.addComma(rewardPrice) + '원');
		} else if (hasDefaultDiscount && hasAddDiscount) {
			$first.show();
			$second.show();
			$third.show();

			$('#maximumBenefitPricePopup header.pop-header h4.tit span').html('최대혜택가');

			$first.find('div.price span.txt').html('판매가');
			$first.find('div.price span.won').html(vcui.number.addComma(originalPrice) + '원');

			if (memberDiscountPrice !== '0') {
				firstLis += '<li><span class="txt">회원 할인</span><span class="won">-' + vcui.number.addComma(memberDiscountPrice) + '원</li>';
			}

			if (extraDiscountPrice !== '0') {
				firstLis += '<li><span class="txt">추가 할인</span><span class="won">-' + vcui.number.addComma(extraDiscountPrice) + '원</li>';
			}

			if (couponDiscountPrice !== '0') {
				firstLis += '<li><span class="txt">쿠폰 할인' + (couponDiscountRate !== '0' ? ' ' + couponDiscountRate + '%' : '') + '</span><span class="won">-' + vcui.number.addComma(couponDiscountPrice) + '원</li>';
			}

			if (firstLis !== '') {
				$first.append('<ul class="discount-price">' + firstLis + '</ul>');
			}
			
			$second.find('div.price span.won').html(vcui.number.addComma(discountApprPrice) + '원');

			if (cardCashBackPrice !== '0') {
				secondLis += '<li><span class="txt">캐시백 (최대)</span><span class="won">-' + vcui.number.addComma(cardCashBackPrice) + '원</li>';
			}

			if (apprDateDiscountPrice !== '0') {
				secondLis += '<li><span class="txt">결제일 할인' + (apprDateDiscountRate !== '0' ? ' ' + apprDateDiscountRate + '% (최대)' : '') + '</span><span class="won">-' + vcui.number.addComma(apprDateDiscountPrice) + '원</li>';
			}

			if (secondLis !== '') {
				$second.append('<ul class="discount-price">' + secondLis + '</ul>');
			}

			$third.find('span.won').html(vcui.number.addComma(rewardPrice) + '원');
		} else if (hasDefaultDiscount) {
			$first.show();
			$second.show();

			// 가격 표시 css 적용위해 object 삭제(20230702)
			$second.addClass("last")

			$('#maximumBenefitPricePopup header.pop-header h4.tit span').html('최대혜택가');

			$first.find('div.price span.txt').html('판매가');
			$first.find('div.price span.won').html(vcui.number.addComma(originalPrice) + '원');

			if (memberDiscountPrice !== '0') {
				firstLis += '<li><span class="txt">회원 할인</span><span class="won">-' + vcui.number.addComma(memberDiscountPrice) + '원</li>';
			}

			if (extraDiscountPrice !== '0') {
				firstLis += '<li><span class="txt">추가 할인</span><span class="won">-' + vcui.number.addComma(extraDiscountPrice) + '원</li>';
			}

			if (couponDiscountPrice !== '0') {
				firstLis += '<li><span class="txt">쿠폰 할인' + (couponDiscountRate !== '0' ? ' ' + couponDiscountRate + '%' : '') + '</span><span class="won">-' + vcui.number.addComma(couponDiscountPrice) + '원</li>';
			}

			if (firstLis !== '') {
				$first.append('<ul class="discount-price">' + firstLis + '</ul>');
			}

			$second.find('div.price span.won').html(vcui.number.addComma(discountApprPrice) + '원');
		} else if (hasAddDiscount) {
			$first.show();
			$third.show();

			$('#maximumBenefitPricePopup header.pop-header h4.tit span').html('최대혜택가');

			$first.find('div.price span.txt').html('판매가');
			$first.find('div.price span.won').html(vcui.number.addComma(originalPrice) + '원');

			if (cardCashBackPrice !== '0') {
				firstLis += '<li><span class="txt">캐시백 (최대)</span><span class="won">-' + vcui.number.addComma(cardCashBackPrice) + '원</li>';
			}

			if (apprDateDiscountPrice !== '0') {
				firstLis += '<li><span class="txt">결제일 할인' + (apprDateDiscountRate !== '0' ? ' ' + apprDateDiscountRate + '% (최대)' : '') + '</span><span class="won">-' + vcui.number.addComma(apprDateDiscountPrice) + '원</li>';
			}

			if (firstLis !== '') {
				$first.append('<ul class="discount-price">' + firstLis + '</ul>');
			}

			$third.find('span.won').html(vcui.number.addComma(rewardPrice) + '원');
		} else {
			return;
		}
		
		// 추가 헤택
		var memberShipPointText = $anchorEl.data('member-ship-point-text') || '';
		//var giftCashBackText = $anchorEl.data('gift-cash-back-text') || '';  //BTOCSITE-76016 최대혜택가 영역의 사은품 노출- 기존 변수 삭제(20240925)
		var purchaseGiftListStr = $anchorEl.data('purchase-gift-list'); //BTOCSITE-76016 최대혜택가 영역의 사은품 노출 추가 - 리스트 형식 변경(20240925)

		var purchaseGiftList = [];
		if(purchaseGiftListStr !=null && purchaseGiftListStr !=""){
			//jsonparse 사용 list 변환시 특수 문자 파싱 에러 있어서 split 사용 함 (ex: [♡바디필로우 증정♡,(포토리뷰) 멤버십포인트(5만원)])
			purchaseGiftList = purchaseGiftListStr.substring(1, purchaseGiftListStr.length - 1).split(',');
		}

		popupBody.find('div.additional-benefits').hide();
		if (memberShipPointText !== '' || purchaseGiftList.length > 0) {
			popupBody.find('div.additional-benefits').show();
			popupBody.find('div.additional-benefits ul').children().remove();
			if (memberShipPointText !== '') {
				popupBody.find('div.additional-benefits ul').append('<li>+ ' + memberShipPointText + '</li>');
			}
			if (purchaseGiftList.length > 0) {
				$.each(purchaseGiftList, function(index, item) {
					popupBody.find('div.additional-benefits ul').append('<li>+ ' + item + '</li>');
				});
			}
		}

		$('#maximumBenefitPricePopup').vcModal("show");
	});
	$(document).on('click', '#maximumBenefitPricePopup .ui_modal_close', function(){
		$('#maximumBenefitPricePopup').vcModal("hide");
	});
	// PLP 최대 혜택가 팝업 이벤트 end

	// PLP 내일배송 팝업 이벤트 start
	$(document).on('click', '.item-bottom-tag .tomorrow', function(){
		$('#popupPTomorrowDelivery').vcModal("show");
	});
	$(document).on('click', '#popupPTomorrowDelivery .ui_modal_close', function(){
		$('#popupPTomorrowDelivery').vcModal("hide");
	});
	// PLP 내일배송 팝업 이벤트 end
	// PLP 다품목할인 팝업 이벤트 start
	$(document).on('click', '.item-bottom-tag .multi', function(){
		$('#popupMultiSale').vcModal("show");
	});
	$(document).on('click', '#popupMultiSale .ui_modal_close', function(){
		$('#popupMultiSale').vcModal("hide");
	});
	// PLP 다품목할인 팝업 이벤트 end
	// PLP 툴팁 팝업 - 내일배송 start
	$(document).on('click', '.plp-tooltip-item .tag.tomorrow', function() {
		$(this).parents().parents().find('.tooltip-box').removeClass('active');
		$(this).next('.tooltip-box.tomorrow').addClass('active');
	});
	$(document).on('click', '.plp-tooltip-item .tooltip-box.tomorrow .btn-close', function() {
		$(this).parents().removeClass('active');
	});
	// PLP 툴팁 팝업 - 내일배송 end
	// PLP 툴팁 팝업 - 다품목할인 start
	$(document).on('click', '.plp-tooltip-item .tag.multi', function() {
		$(this).parents().parents().find('.tooltip-box').removeClass('active');
		$(this).next('.tooltip-box.multi').addClass('active');
	});
	$(document).on('click', '.plp-tooltip-item .tooltip-box.multi .btn-close', function() {
		$(this).parents().removeClass('active');
	});

	// 카테고리 필터 start
	var choiseFilterSwiperEvent = function() {
		if($('.plp-afilter-choice .swiper-slide').length) {
			var choiseFilterSwiper = new Swiper('.choice-filter-wrap', {
				slidesPerView: 'auto',
				resistance: true,
				resistanceRatio: 0,
				observer: true,
				observeParents: true,
				spaceBetween: 4,
				slideToClickedSlide: true,
				// centeredSlides : true,
				a11y: false
			});
		}
	}
	choiseFilterSwiperEvent();
	$(window).on('plpFilter.swiper.init', function() {
		choiseFilterSwiperEvent();
	});
	// 카테고리 필터 end

	// 비디오 배너 start
	$(".video-button-wrap").find(".video-button").on("click", function () {
		if ($(this).hasClass("pause")) {
			$(this).removeClass("pause");
			$(this).parent().siblings("video").get(0).pause();
			$(this).parent().siblings('.mobile-dimmed').removeClass('active');
		} else {
			$(this).addClass("pause");
			$(this).parent().siblings("video").get(0).play();
			$(this).parent().siblings('.mobile-dimmed').addClass('active');
		}
	});
	// 비디오 배너 end

	// <!-- BTOCSITE-64954 PLP 소카테고리 전체보기 아이콘 선택 시 오류
	var $cateWrap = $('.plp-new .cate-m'); // 카테고리
	$cateWrap.addClass("is-plp-new");

	/**
	 * 카테고리 가로 스크롤 초기화
	 */
	 function initCateSmoothScroll($cateWrapCurrent){
		if($cateWrapCurrent){
			initCateSmoothScrollNext($cateWrapCurrent)
		}else{
			$cateWrap.each(function(){
				initCateSmoothScrollNext($(this));
			})
		}
	}
	
	function initCateSmoothScrollNext($cateWrapCurrent) {
		var $smoothScrollTarget = $cateWrapCurrent.find('.ui_smooth_tab')
		destroyCateSmoothScroll($cateWrapCurrent);

		redefineScrollOfTab($smoothScrollTarget); // smoothScrollTab 내부에 새로 정의한 smoothScroll 로 교체

		// smoothscroll init 콜백 대체용으로 사용 ( initialize 에서 무조건 refresh() 호출하기 때문 )
		$smoothScrollTarget.off('smoothscrollinit').one('smoothscrollinit', function (e) {
			//var smoothScroll = $(e.currentTarget).vcSmoothScroll('instance', false);
			//smoothScroll.scrollTo(0,0,0); // 초기화 후 drag 안되는 버그 존재하여 추가함, smoothScroll 내부 self.x NaN 이 이유, scrollTo > _translate 발생 시켜 0 지정되도록 // BTOCSITE-60078 smoothscrollinit 로 변경하여 제거 
			
			cateActIntoView($cateWrapCurrent);
		});
	}

	/**
	 * SmoothScrollTab 내부 SmoothScroll 교체
	 * @param {jQueryElement} $smoothScroll .ui_smooth_tab 
	 */
	function redefineScrollOfTab($smoothScroll) {
		$smoothScroll.vcSmoothScroll({
			getViewWidth: function () { // 모바일 오른쪽 그라데이션 제외한 사이즈 전달
				var wrapWidth = $smoothScroll.innerWidth();
				var $expandBtn = $smoothScroll.closest('.cate-list').find('.btn-expand');
				var expandBtnWid = $expandBtn.is(':hidden') ? 200 : 46; // css 가상요소에 정의된 그라데이션 때문에 고정값, pc는 좌우 각각 100px 

				return wrapWidth - expandBtnWid;	
			},
			getScrollerSpace: function() { // BTOCSITE-60078 [모니터링 G] 오브제 컬렉션 > 카테고리 선택 > 키보드 방향키로 이동시 카테고리명 잘리는 현상
				return { left: 100, top: 0 };
			}
		});

		var smoothScroll = $smoothScroll.vcSmoothScroll('instance', false);
		var $smoothScrollTab = $smoothScroll.parent('.ui_smooth_scrolltab');
		var smoothScrollTab = $smoothScrollTab.vcSmoothScrollTab('instance', false);

		$smoothScrollTab.off('.KRP0007-3'); // 이벤트 중복 방지
		if (!smoothScroll) return;
		
		// SmoothScroll 교체 함수
		var redefine = function () {
			$smoothScrollTab.vcSmoothScrollTab('setSmoothScroll', smoothScroll);
		}
		
		if (smoothScrollTab) {
			redefine();
		} else {
			$smoothScrollTab.one('smoothscrolltabinit.KRP0007-3', redefine);
		}
	}

	/**
	 * 카테고리 가로 스크롤 파괴
	 */
	 function destroyCateSmoothScroll($cateWrapCurrent) {
		var $smoothScrollTarget = $cateWrapCurrent.find('.ui_smooth_tab');

		$smoothScrollTarget.vcSmoothScroll('destroy');
	}

	initCateSmoothScroll(); // 모바일 오른쪽 그라데이션 영역 제외하기 위해 getViewWidth 및 데스크탑 < > 버튼 대응 위해 getScrollerSpace 옵션 적용 (.btn-expand 버튼으로 닫을 때 smoothScroll 재정의에도 사용)

	// 카테고리 확장 클릭 이벤트
	function mobCategoryExpanded() {
		$cateWrap.on('click', 'button.btn-expand', function () {
			var $cateWrapCurrent = $(this).closest('.cate-m')
			if($cateWrapCurrent.hasClass('expanded')) {
				// 닫기
				$cateWrapCurrent.removeClass('expanded');

				// smoothScroll 재생성
				initCateSmoothScroll($cateWrapCurrent);

				$(window).trigger('catetabclose');
			} else {
				// 열기 
				$cateWrapCurrent.addClass('expanded');
				
				// smoothScroll 제거
				destroyCateSmoothScroll($cateWrapCurrent);

				$(window).trigger('catetabopen');
			}
		});
	}

	mobCategoryExpanded();

	// 탭 활성화로 가로 스크롤 이동
	function cateActIntoView($cateWrapCurrent) {
		if($cateWrapCurrent){
			cateActIntoViewNext($cateWrapCurrent)
		}else{
			$cateWrap.each(function(){
				cateActIntoViewNext($(this));
			})
		}
	}
	function cateActIntoViewNext($cateWrapCurrent) {
		var $expandBtn = $cateWrapCurrent.find('button.btn-expand');
		var smoothScroll = $cateWrapCurrent.find('.ui_smooth_tab').vcSmoothScroll('instance', false);

		// 열려있으면 닫기
		if ($cateWrapCurrent.is('.expanded')) $expandBtn.trigger('click');

		if (smoothScroll) {
			var li = $cateWrapCurrent.find('li input:checked').closest('li');
			if (li.length) smoothScroll.scrollToElement(li.get(0), 0, false);
		}
	}
	// BTOCSITE-64954 PLP 소카테고리 전체보기 아이콘 선택 시 오류 -->

	$('.best-top-selectbox .ui_selectbox').vcSelectbox('update');

	/* PLP 툴팁 레이어 팝업 start */
	function plpLayerPopResize() {
		$(".layer-body").css("height", "");
		$(".plp-new-layer").each(function(){
			var $this = $(this);
			var calcCont1 = $this.find(".layer-inner").height();
			var calcCont2 = $this.find(".layer-inner").find(".layer-header").outerHeight(true);
			$this.find(".layer-body").css("height", calcCont1 - calcCont2);
		});
	}
	$(document).on("click", ".plp-new-layer-cont", function(){
		var btClassName = $(this).find("em").attr("class");
		$('html').css("overflow", "hidden");
		$(document).find("section." + btClassName).addClass("active");
		plpLayerPopResize();
	});
	$(document).on("click", ".plp-new-layer .layer-header-close", function(){
		$(this).parents(".plp-new-layer").removeClass("active");
		$('html').css("overflow", "");
	});
	$(document).on("click", ".plp-new-layer .layer-dim", function(){
		$(this).parents(".plp-new-layer").removeClass("active");
		$('html').css("overflow", "");
	});
	$(window).on("resize", function(){
		plpLayerPopResize();
	});
	/* PLP 툴팁 레이어 팝업 end */
	/*
    $(document).on("click", "#ownchk", function(){
        $("#KRP0007200_modalpop01").addClass("new-max-width");
        setTimeout(function(){
            $("#KRP0007200_modalpop01").vcModal('show');
        }, 100);
    });
    $(document).on("click", ".my-product-list-plp", function(){
        $("#KRP0007200_modalpop01").addClass("new-max-width");
        setTimeout(function(){
            $("#KRP0007200_modalpop01").vcModal('show');
        }, 100);
    });
	*/
	function plpTopTabTitleClickNone() {
		var titleW = $(".is-plp-header").find(".nav-item").outerWidth(true);
		var titleH = $(".is-plp-header").find(".nav-item").outerHeight(true);
		$(".is-plp-header").find("div").remove(".is-non-click");
		$(".is-plp-header").append("<div class='is-non-click'></div>");
		$(".is-non-click").css("width", titleW).css("height", titleH);;
	}
	plpTopTabTitleClickNone();
	$(document).on("click", ".is-plp-header li a", function(){
		var leftContent = $(this).parents(".mobile-nav-wrap").find(".nav-item");
		var rightContent = $(this).text();
		$(this).parent().parent().find("li").removeClass("on");
		$(this).parent().addClass("on");
		$(this).parents(".nav-category-container").css("display", "none");
		$(this).parents(".nav-category-container").prev(".nav-item").removeClass("on");
		leftContent.text(rightContent);
		plpTopTabTitleClickNone();
	});
	$(window).resize(function(){
		if ($(".is-plp-header").find(".nav-item").hasClass("on")) {
			if (window.innerWidth > 767) {
				$("body").css("position", "static");
				$("body").css("overflow", "visible");
				$("body").css("width", "auto");
				$(".is-plp-header").find(".nav-item").removeClass("on");
				$(".is-plp-header").find(".nav-category-container").css("display", "none");
			}
		}
	});
	$(document).on("click", ".tooltip-trigger", function(){
		$(this).parents(".tooltip-wrap").find(".toottip-box").addClass("active");
	});

	/*
	function plpTooltipBoxSize() {
		$(".tooltip-wrap-new").each(function(){
			var $this = $(this);
			var size1 = $this.find(".tooltip-box-new");
			var size2 = size1.find(".ui_accord_content");
			var calcSize = size2.innerHeight();
			setTimeout(function(){
				size1.css("height", calcSize);
			}, 10);
			console.log(size1.innerHeight(), size2.innerHeight(), calcSize);
		});
	}
	plpTooltipBoxSize();
	$(document).on("click", ".tooltip-wrap-new", function(){
		var $this = $(this);
		var size1 = $this.find(".tooltip-box-new");
		var size2 = size1.find(".ui_accord_content");
		var calcSize = size2.innerHeight();
		setTimeout(function(){
			size1.css("height", calcSize);
		}, 10);
		console.log(size1.innerHeight(), size2.innerHeight(), calcSize);
	});
	$(document).on("click", ".ui_tooltip-target", function(){
		var $this = $(this);
		var wid1 = $this.parents(".product-card-list").width();
		var pos1 = $this.parents(".product-card-list").offset().left;
		var pos2 = $this.parents(".normal-card").offset().left;
		var pos2_1 = $this.parents(".normal-card").prev().offset().left;
		var pos3 = wid1 / 3;
		var pos4 = pos3 * 2;
	});
	*/

	function plpLoadingCheck() {
		$(".plp-new-section").removeClass("is-loading");
		$(".plp-new-section").removeClass("length2");
		$(".plp-new-section").removeClass("length3");
		$(".plp-new-section").removeClass("length4");
		$("body").removeClass("is-loading");
	}

	$(document).on("click", ".choice-filter-list button", function(){
		//console.log("console");
	});
	function plpTopCheckRight() {
		var target = $(".plp-afilter-inner");
		var targetReset = target.find(".item-reset");
		var targetMenu = target.find(".afilter-btn-area");
		if (targetReset.length < 1) {
			target.addClass("reset-none");
		}
		if (targetMenu.length < 1) {
			target.addClass("menu-none");
		}
	}
	/*
	function headerItemCheck() {
		var target1 = $(".header-wrap.type-new").find(".header-top").find(".shortcut").innerWidth();
		var target2 = $(".mobile-nav-wrap.sub-renew-nav-wrap");
		var calc = $("body").innerWidth() - target1;
		target2.css("width", calc - 50);
	}
	*/
	function filterMiddleContentCheck() {
		var target1 = $(".list-sorting-outter").find(".list-sorting").find(".check-item").length;
		var target2 = $(".product-list-top");
		if(target1 < 1) {
			target2.addClass("is-non-content");
		} else if (target1 > 0) {
			target2.removeClass("is-non-content");
		}
	}
	function categoryCountCheck() {
		if($(".plp-new-section.category-list.pc").find(".plp-category-swiper").find(".swiper-wrapper").find(".swiper-slide").length < 3) {
			$(".plp-new-section.category-list.pc").find(".plp-category-swiper").addClass("is-mo-center");
		}
		else if($(".plp-new-section.category-list.pc").find(".plp-category-swiper").find(".swiper-wrapper").find(".swiper-slide").length > 2) {
			$(".plp-new-section.category-list.pc").find(".plp-category-swiper").removeClass("is-mo-center");
		}

		if($(".plp-new-section.smart-lineup").find(".plp-category-swiper").find(".swiper-wrapper").find(".swiper-slide").length < 3) {
			$(".plp-new-section.smart-lineup").find(".plp-category-swiper").addClass("is-mo-center");
		}
		else if($(".plp-new-section.smart-lineup").find(".plp-category-swiper").find(".swiper-wrapper").find(".swiper-slide").length > 2) {
			$(".plp-new-section.smart-lineup").find(".plp-category-swiper").removeClass("is-mo-center");
		}
	}
	
	window.onload = function() {
		plpTopCheckRight();
		plpLoadingCheck();
		filterMovementEvent();
		// headerItemCheck();
		filterMiddleContentCheck();
		categoryCountCheck();
		$(window).resize(function(){
			// headerItemCheck();
			filterMiddleContentCheck();
			categoryCountCheck();
		});
	}

	function filterMovementEvent() {
		if(window.innerWidth > 1024){
			$(".plp-new .lay-filter").each(function(){
				$this = $(this);
				// var scrFilterHei = $(".plp-new .cate-m").outerHeight(true);
				var scrContHei = $this.parent().parent().css("margin-top");
				var scrContHeiInt = parseInt(scrContHei, 10);
				// var scrTarget = $(".plp-new .lay-filter").parent().offset().top - scrFilterHei + scrContHeiInt;
				var scrTarget = $this.parent().offset().top - scrContHeiInt - 30;
				var scrTargetHei = $this.outerHeight(true);
				var scrTargetHei2 = $this.parent().next().outerHeight(true);
				var scrListContHei = $this.parent().next().find(".card-list-content").outerHeight(true);
				var scrListContHei2 = $this.parent().next().find(".product-list-top").outerHeight(true);
				var scrListContHei3 = $this.parent().next().find(".pagination").outerHeight(true);
				var scrTargetCalc1 = scrTargetHei2 - scrTargetHei;
				var scrTargetCalc2 = scrTarget + scrTargetCalc1;
				var scrTargetCalc3 = scrTargetCalc2 - scrListContHei3;
				var scrListContHeiCalc = scrTargetHei2 - scrListContHei - scrListContHei2;
				var scrWindow = $(window).scrollTop();
				var unitLength = $this.parents(".plp-new-section-filter-cont").next(".plp-new-section-list-cont").find(".normal-card").length;
				var unitContainerHeight = $this.parents(".plp-new-section-filter-cont").next(".plp-new-section-list-cont").outerHeight(true);
				if(scrTarget < scrWindow && scrWindow < scrTargetCalc3) {
					if(unitLength > 0) {
						$this.removeClass("is-fixed-content-stop");
						$this.addClass("is-fixed-content");
						$this.parent().next().addClass("left-margin");
						$this.css("bottom", '');
						$this.css("max-height", '');
					}
					else {
						$this.removeClass("is-fixed-content");
						$this.removeClass("is-fixed-content-stop");
						$this.parent().next().removeClass("left-margin");
						$this.css("bottom", '');
						$this.css("max-height", unitContainerHeight - scrListContHei3);
					}
				}
				else if(scrWindow > scrTargetCalc3) {
					if(unitLength > 0) {
						$this.removeClass("is-fixed-content");
						$this.addClass("is-fixed-content-stop");
						$this.css("bottom", '');
						$this.css("max-height", '');
					}
					else {
						$this.removeClass("is-fixed-content");
						$this.removeClass("is-fixed-content-stop");
						$this.parent().next().removeClass("left-margin");
						$this.css("bottom", '');
						$this.css("max-height", unitContainerHeight - scrListContHei3);
					}
				}
				else {
					if(unitLength > 0) {
						$this.css("max-height", '');
					}
					else {
						$this.css("max-height", unitContainerHeight - scrListContHei3);
					}
					$this.removeClass("is-fixed-content");
					$this.removeClass("is-fixed-content-stop");
					$this.parent().next().removeClass("left-margin");
					$this.css("bottom", '');
				}
			});
		}
	}
	function listItemRemoveH(){
		$(".item-top-badge").css("height", "");
		$(".top-title-main").css("height", "");
		$(".item-middle-prdtype").css("height", "");
		$(".item-timedeal").css("height", "");
		$(".middle-info-inner").css("height", "");
	}
	function listItemSizeCheck() {
		$('.product-card-list .card-list-item').removeClass("first");
		$('.product-card-list .card-list-item').removeClass("second");
		$('.product-card-list .card-list-item').removeClass("third");
		// BTOCSITE-75547 START
		if ($('.grid-change-cont').css('display') === 'block' && $(".grid-change-bt").hasClass("list-type")) {
			$('.plp-new-section-list-cont').removeClass('twin-type').addClass('list-type');
		} else if ($('.grid-change-cont').css('display') === 'block' && $(".grid-change-bt").hasClass("twin-type")) {
			$('.plp-new-section-list-cont').removeClass('list-type').addClass('twin-type');
		}
		// BTOCSITE-75547 END
		if($("body").innerWidth() > 1380) {
			var pIndex = -1;
			$('.product-card-list .card-list-item').each(function(index){
				if($(this).css('display') == 'none' || $(this).hasClass('recommend-wrap') /*BTOCSITE-76923*/ ){return;}
				++pIndex;
				if(pIndex % 3 == 0) {
					$(this).addClass('first');
				}
				else if(pIndex % 3 == 1) {
					$(this).addClass('second');
				}
				else {
					$(this).addClass('third');
				}

				setTimeout(function(){
					listItemRemoveH();
					$('.product-card-list .card-list-item.second').each(function(index) {
						var size1_01 = $(this).prev(".first").find(".item-top-badge");
						var size2_01 = $(this).find(".item-top-badge");
						var size3_01 = $(this).next(".third").find(".item-top-badge");
						var size1_01Val = size1_01.outerHeight();
						var size2_01Val = size2_01.outerHeight();
						var size3_01Val = size3_01.outerHeight();
						var maxVal01 = Math.max(size1_01Val, size2_01Val, size3_01Val);

						var size1_02 = $(this).prev(".first").find(".top-title-main");
						var size2_02 = $(this).find(".top-title-main");
						var size3_02 = $(this).next(".third").find(".top-title-main");
						var size1_02Val = size1_02.outerHeight();
						var size2_02Val = size2_02.outerHeight();
						var size3_02Val = size3_02.outerHeight();
						var maxVal02 = Math.max(size1_02Val, size2_02Val, size3_02Val);

						var size1_03 = $(this).prev(".first").find(".item-middle-prdtype");
						var size2_03 = $(this).find(".item-middle-prdtype");
						var size3_03 = $(this).next(".third").find(".item-middle-prdtype");
						var size1_03Val = size1_03.outerHeight();
						var size2_03Val = size2_03.outerHeight();
						var size3_03Val = size3_03.outerHeight();
						var maxVal03 = Math.max(size1_03Val, size2_03Val, size3_03Val);

						var size1_04 = $(this).prev(".first").find(".item-timedeal");
						var size2_04 = $(this).find(".item-timedeal");
						var size3_04 = $(this).next(".third").find(".item-timedeal");
						var size1_04Val = size1_04.outerHeight();
						var size2_04Val = size2_04.outerHeight();
						var size3_04Val = size3_04.outerHeight();
						var maxVal04 = Math.max(size1_04Val, size2_04Val, size3_04Val);

						var size1_05 = $(this).prev(".first").find(".middle-info-inner");
						var size2_05 = $(this).find(".middle-info-inner");
						var size3_05 = $(this).next(".third").find(".middle-info-inner");
						var size1_05Val = size1_05.outerHeight();
						var size2_05Val = size2_05.outerHeight();
						var size3_05Val = size3_05.outerHeight();
						var maxVal05 = Math.max(size1_05Val, size2_05Val, size3_05Val);

						// 유닛 최상단 뱃지
						size1_01.css("height", maxVal01);
						size2_01.css("height", maxVal01);
						size3_01.css("height", maxVal01);

						// 유닛 메인 타이틀
						size1_02.css("height", maxVal02);
						size2_02.css("height", maxVal02);  
						size3_02.css("height", maxVal02);

						// 유닛 제품 타입 선택
						size1_03.css("height", maxVal03);
						size2_03.css("height", maxVal03);
						size3_03.css("height", maxVal03);

						// 유닛 타임딜 영역
						size1_04.css("height", maxVal04);
						size2_04.css("height", maxVal04);
						size3_04.css("height", maxVal04);

						// 유닛 스펙 영역
						size1_05.css("height", maxVal05);
						size2_05.css("height", maxVal05);
						size3_05.css("height", maxVal05);
					});
				}, 10);
			});
		} else if($("body").innerWidth() < 1381 && $("body").innerWidth() > 767) {
			/*
			$('.plp-new-section-list-cont').removeClass('twin-type').addClass('list-type');
			$('.grid-change-bt').removeClass('twin-type').addClass('list-type');
			$(".grid-change-bt").find(".twin-ico").removeClass("active");
			$(".grid-change-bt").find(".list-ico").addClass("active");
			*/
			var tIndex = -1;
			$('.product-card-list .card-list-item').each(function(index){
				if($(this).css('display') == 'none'){return;}
				++tIndex;
				if(tIndex % 2 == 0) {
					$(this).addClass('first');
				}
				else {
					$(this).addClass('second');
				}

				setTimeout(function(){
					listItemRemoveH();
					$('.product-card-list .card-list-item.second').each(function(index) {
						var size1_01 = $(this).prev(".first").find(".item-top-badge");
						var size2_01 = $(this).find(".item-top-badge");
						var size1_01Val = size1_01.outerHeight();
						var size2_01Val = size2_01.outerHeight();
						var maxVal01 = Math.max(size1_01Val, size2_01Val);

						var size1_02 = $(this).prev(".first").find(".top-title-main");
						var size2_02 = $(this).find(".top-title-main");
						var size1_02Val = size1_02.outerHeight();
						var size2_02Val = size2_02.outerHeight();
						var maxVal02 = Math.max(size1_02Val, size2_02Val);

						var size1_03 = $(this).prev(".first").find(".item-middle-prdtype");
						var size2_03 = $(this).find(".item-middle-prdtype");
						var size1_03Val = size1_03.outerHeight();
						var size2_03Val = size2_03.outerHeight();
						var maxVal03 = Math.max(size1_03Val, size2_03Val);

						var size1_04 = $(this).prev(".first").find(".item-timedeal");
						var size2_04 = $(this).find(".item-timedeal");
						var size1_04Val = size1_04.outerHeight();
						var size2_04Val = size2_04.outerHeight();
						var maxVal04 = Math.max(size1_04Val, size2_04Val);

						var size1_05 = $(this).prev(".first").find(".middle-info-inner");
						var size2_05 = $(this).find(".middle-info-inner");
						var size1_05Val = size1_05.outerHeight();
						var size2_05Val = size2_05.outerHeight();
						var maxVal05 = Math.max(size1_05Val, size2_05Val);

						// 유닛 최상단 뱃지
						size1_01.css("height", maxVal01);
						size2_01.css("height", maxVal01);

						// 유닛 메인 타이틀
						size1_02.css("height", maxVal02);
						size2_02.css("height", maxVal02);  

						// 유닛 제품 타입 선택
						size1_03.css("height", maxVal03);
						size2_03.css("height", maxVal03);

						// 유닛 타임딜 영역
						size1_04.css("height", maxVal04);
						size2_04.css("height", maxVal04);

						// 유닛 스펙 영역
						size1_05.css("height", maxVal05);
						size2_05.css("height", maxVal05);
					});
				}, 10);
			});
		} else if($("body").innerWidth() >= 360 && $("body").innerWidth() < 768 && $(".grid-change-bt").hasClass("twin-type")) { // BTOCSITE-75547
			var mIndex = -1;
			$('.product-card-list .card-list-item.normal-card').each(function(index){
				if($(this).css('display') == 'none'){return;}
				++mIndex;
				if(mIndex % 2 == 0) {
					$(this).addClass('first');
				}
				else {
					$(this).addClass('second');
				}

				setTimeout(function(){
					listItemRemoveH();
					$('.product-card-list .card-list-item.second').each(function(index) {
						var size1_01 = $(this).prev(".first").find(".item-top-badge");
						var size2_01 = $(this).find(".item-top-badge");
						var size3_01 = $(this).prev(".list-small-banner").prev(".first").find(".item-top-badge");
						var size1_01Val = size1_01.outerHeight();
						var size2_01Val = size2_01.outerHeight();
						var size3_01Val = size3_01.outerHeight();
						var maxVal01 = Math.max(size1_01Val, size2_01Val, size3_01Val);

						var size1_02 = $(this).prev(".first").find(".top-title-main");
						var size2_02 = $(this).find(".top-title-main");
						var size3_02 = $(this).prev(".list-small-banner").prev(".first").find(".top-title-main");
						var size1_02Val = size1_02.outerHeight();
						var size2_02Val = size2_02.outerHeight();
						var size3_02Val = size3_02.outerHeight();
						var maxVal02 = Math.max(size1_02Val, size2_02Val, size3_02Val);

						var size1_03 = $(this).prev(".first").find(".item-middle-prdtype");
						var size2_03 = $(this).find(".item-middle-prdtype");
						var size3_03 = $(this).prev(".list-small-banner").prev(".first").find(".item-middle-prdtype");
						var size1_03Val = size1_03.outerHeight();
						var size2_03Val = size2_03.outerHeight();
						var size3_03Val = size3_03.outerHeight();
						var maxVal03 = Math.max(size1_03Val, size2_03Val, size3_03Val);

						var size1_04 = $(this).prev(".first").find(".item-timedeal");
						var size2_04 = $(this).find(".item-timedeal");
						var size3_04 = $(this).prev(".list-small-banner").prev(".first").find(".item-timedeal");
						var size1_04Val = size1_04.outerHeight();
						var size2_04Val = size2_04.outerHeight();
						var size3_04Val = size3_04.outerHeight();
						var maxVal04 = Math.max(size1_04Val, size2_04Val, size3_04Val);

						var size1_05 = $(this).prev(".first").find(".middle-info-inner");
						var size2_05 = $(this).find(".middle-info-inner");
						var size3_05 = $(this).prev(".list-small-banner").prev(".first").find(".middle-info-inner");
						var size4_05 = $(this).next(".first");
						var size1_05Val = size1_05.outerHeight();
						var size2_05Val = size2_05.outerHeight();
						var size3_05Val = size3_05.outerHeight();
						var maxVal05 = Math.max(size1_05Val, size2_05Val, size3_05Val);

						// 유닛 최상단 뱃지
						size1_01.css("height", maxVal01);
						size2_01.css("height", maxVal01);
						size3_01.css("height", maxVal01);

						// 유닛 메인 타이틀
						size1_02.css("height", maxVal02);
						size2_02.css("height", maxVal02); 
						size3_02.css("height", maxVal02);

						// 유닛 제품 타입 선택
						size1_03.css("height", maxVal03);
						size2_03.css("height", maxVal03);
						size3_03.css("height", maxVal03);

						// 유닛 타임딜 영역
						size1_04.css("height", maxVal04);
						size2_04.css("height", maxVal04);
						size3_04.css("height", maxVal04);

						// 유닛 스펙 영역
						size1_05.css("height", maxVal05);
						size2_05.css("height", maxVal05);
						size3_05.css("height", maxVal05);

						if( maxVal05 == 0 ) {
							size1_05.parent('.item-middle-info').css('padding', '0');
							size2_05.parent('.item-middle-info').css('padding', '0');
							size3_05.parent('.item-middle-info').css('padding', '0');
						}

						if( size1_05.find('li').length == 0 ) {
							size1_05.parent('.item-middle-info').css('background', '#fff');
						} else if( size2_05.find('li').length == 0 ) {
							size2_05.parent('.item-middle-info').css('background', '#fff');
						} else if( size3_05.find('li').length == 0 ) {
							size3_05.parent('.item-middle-info').css('background', '#fff');
						}

						if( size4_05.next(".second") ) {
							if( size4_05.find('.middle-info-inner li').length == 0 ) {
								size4_05.find('.middle-info-inner').parent('.item-middle-info').css('padding', '0');
							}
						}
					});
				}, 10);
			});

			if( $('.product-card-list .card-list-item.normal-card .middle-info-inner li').length == 0 ) {
				$('.product-card-list .card-list-item.normal-card .middle-info-inner').parent('.item-middle-info').css('padding', '0');
			}
			// BTOCSITE-75547 START
		} else if ($("body").innerWidth() < 360) {
			$('.plp-new-section-list-cont').removeClass('twin-type').addClass('list-type');
			// BTOCSITE-75547 END
		} else {
			setTimeout(function(){
				listItemRemoveH();
			});
		}
	}

	function unitTypeSliderWidthCheck() {
		$(".prd-type-cont1").each(function(){
			var $this = $(this);
			var thumbList = $this.find(".swiper-wrapper");
			var thumbListWrap = $this.find(".swiper-wrapper").parent();

			if(thumbList.width() > thumbListWrap.width()) {
				thumbListWrap.find(".item-middle-prdtype-arrow").css("display", "flex");
			} else if(thumbList.width() < thumbListWrap.width()) {
				thumbListWrap.find(".item-middle-prdtype-arrow").css("display", "none");
			}
		});
		$(".prd-type-cont2").each(function(){
			var $this = $(this);
			// var thumbList = $this.find(".swiper-wrapper");
			var thumbListWrap = $this.find(".swiper-wrapper").parent();
            var thumbListItem = $this.find(".swiper-slide").outerWidth();
            var thumbListCount = $this.find(".swiper-slide").length;
            var thumbListInnerCalc = thumbListItem * thumbListCount;
            
            if(thumbListInnerCalc > thumbListWrap.width()){
				thumbListWrap.find(".item-middle-prdtype-arrow").css("display", "flex");
            } else if (thumbListInnerCalc < thumbListWrap.width()){
                thumbListWrap.find(".item-middle-prdtype-arrow").css("display", "none");
            }
		});
	}
	/*
	function unitImgResizeCheck() {
		$(".card-list-item.normal-card").each(function(){
			$this = $(this);
			var target1 = $this.find(".item-middle-thumb a");
			var target1Wid = target1.innerWidth();
			target1.css("height", target1Wid);
		});
	}
	*/

	$(window).resize(function(){
		//listItemSizeCheck2();
		unitTypeSliderWidthCheck();
		//unitImgResizeCheck();
	});

	var widRe = 0;
	$( window ).load( function(){
		widRe = $( window ).width();
	});
	$( window ).resize( function(){
		if( widRe != $( window ).width() ){
			listItemSizeCheck();
			widRe = $( window ).width();
		}
	});

	listItemSizeCheck();
	unitTypeSliderWidthCheck();
	//unitImgResizeCheck();
	$(document).on("click", ".category-list .plp-new-category-list", function(){
		setTimeout(function(){
			listItemSizeCheck();
			//listItemSizeCheck2();
			//unitImgResizeCheck();
			unitTypeSliderWidthCheck();
			filterMiddleContentCheck();
		}, 10);
	});
	$(document).on("click", ".smart-lineup .plp-new-category-list", function(){
		setTimeout(function(){
			listItemSizeCheck();
			//listItemSizeCheck2();
			//unitImgResizeCheck();
			unitTypeSliderWidthCheck();
			filterMiddleContentCheck();
		}, 10);
	});
	$(document).on("click", ".cate-wrap .ui_smooth_tab .rdo-wrap label", function(){
		setTimeout(function(){
			listItemSizeCheck();
			//listItemSizeCheck2();
			//unitImgResizeCheck();
			unitTypeSliderWidthCheck();
			filterMiddleContentCheck();
		}, 10);
	});
	$(document).on("click", ".choice-filter-list button", function(){
		setTimeout(function(){
			listItemSizeCheck();
			//listItemSizeCheck2();
			//unitImgResizeCheck();
			unitTypeSliderWidthCheck();
			filterMiddleContentCheck();
		}, 10);
	});
	$(document).on("click", ".lay-filter .chk-wrap label", function(){
		setTimeout(function(){
			listItemSizeCheck();
			//listItemSizeCheck2();
			//unitImgResizeCheck();
			unitTypeSliderWidthCheck();
			filterMiddleContentCheck();
		}, 10);
	});
	$(document).on("click", ".lay-filter .rdo-wrap label", function(){
		setTimeout(function(){
			listItemSizeCheck();
			//listItemSizeCheck2();
			//unitImgResizeCheck();
			unitTypeSliderWidthCheck();
			filterMiddleContentCheck();
		}, 10);
	});
	$(document).on("click", ".lay-filter-con-plp .s-filter-list li .btn-refresh", function(){
		setTimeout(function(){
			listItemSizeCheck();
			//listItemSizeCheck2();
			//unitImgResizeCheck();
			unitTypeSliderWidthCheck();
			filterMiddleContentCheck();
		}, 10);
	});
	$(document).on("click", ".list-sorting .sort-select-wrap .ui-select-button", function(){
		setTimeout(function(){
			listItemSizeCheck();
			//listItemSizeCheck2();
			//unitImgResizeCheck();
			unitTypeSliderWidthCheck();
			filterMiddleContentCheck();
		}, 10);
	});
	$(document).on("click", ".grid-change-bt", function(){
		setTimeout(function(){
			listItemSizeCheck();
			//listItemSizeCheck2();
			//unitImgResizeCheck();
			unitTypeSliderWidthCheck();
			filterMiddleContentCheck();
		}, 10);
	});
	$(document).on("click", ".swiper prd-type-cont1 label", function(){
		setTimeout(function(){
			listItemSizeCheck();
			//listItemSizeCheck2();
			//unitImgResizeCheck();
		}, 10);
	});
	$(document).on("click", ".swiper prd-type-cont2 label", function(){
		setTimeout(function(){
			listItemSizeCheck();
			//listItemSizeCheck2();
			//unitImgResizeCheck();
		}, 10);
	});

	$(document).on("click", ".btn-moveto-product", function (e) {
		setTimeout(function(){
			listItemSizeCheck();
		}, 300);
	});

	$(document).on("click", ".close-new-plp", function (e) {
		setTimeout(function(){
			listItemSizeCheck();
		}, 300);
	});

	function endScrollCheck() {
		var scr1 = $(window).scrollTop();
		var scr2 = $(".plp-new-section-product-list ").find(".product-card-list").find(".card-list-item").last();
		if (!scr2.length) return; // 퍼블에러 방지
		var scr2Pos = scr2.offset().top;
		if($("body").innerWidth() < 768) {
			if(scr1 > scr2Pos + 100) {
				/* 이벤트 입력 */
			}
		}
	}
	$(window).scroll(function(){
		endScrollCheck();
	});

	/*$(document).on("click", ".comparison-content .comparison-content-button", function(){
		var target1 = $(this);
		if(target1.hasClass("active")) {
			target1.removeClass("active");
		} else {
			target1.addClass("active");
		}
	});*/

	$(document).ready(function(){
		let vh = window.innerHeight * 0.01;
		document.querySelector(".lay-filter .lay-filter-con").style.setProperty('--vh', `${vh}px`);
		window.addEventListener('resize', () => {
			let vh = window.innerHeight * 0.01
			document.querySelector(".lay-filter .lay-filter-con").style.setProperty('--vh', `${vh}px`);
		});
	});

	var _ownProdList = [];
	//var _choiceOwnProd;
	var linkHost = window.LGEAPPHostName === "localhost" ? "https://www.lge.co.kr" : "";

	/**
	 * @method goLogin
	 * @memberof
	 * @return {myCallback}  [로그인 페이지로 이동]
	 */
	var goLogin = function () {
		location.href = linkHost + "/sso/member/login?state=" + encodeURIComponent(location.href.replace(location.origin, ""));
	}

	// 나의 보유제품 소모품만 보기 클릭
	$(document).on('click', '.own_sortview input#ownchk, .check-item input#ownchk_m', function(e) {
		e.preventDefault();

		var that = $(this);
		if (that.data('checked') !== undefined && that.data('checked') === 'true') {
			setTimeout(function() {
				$('.product-list-reselect').hide();
				that.prop('checked', false);
				that.data('checked', 'false');
			}, 100);

			$('.hidden-input-group input[name=myOwnModelCode]').val('');

			// 검색
			$('.hidden-input-group input[name=page]').val('1');
			$(window).trigger('plpFilter.change');
			return;
		}

		// var isLogin = $('.hidden-input-group input[name=isLogin]').val();
		// if (isLogin === '' || isLogin === 'N') {
		//     goLogin();
		// }

		var isLogin = digitalData.hasOwnProperty("userInfo") && digitalData.userInfo.unifyId ? true : false;
		if (!isLogin) {
			//console.log('go Login!!');
			goLogin();
			return false;
		}

		// 보유제품이 없는 경우 보유제품 조회
		if (_ownProdList.length === 0) {
			var ajaxUrl = $('.component.KRP0007.re22').data('myproduct-url');
			$.ajax({
				type: 'post',
				url : ajaxUrl,
				dataType: 'json',
				success: function(result) {
					if (result.status.toUpperCase() !== 'SUCCESS') {
						return;
					}

					_ownProdList = result.data[0].myProducts;
					$('.hidden-input-group input[name=isLogin]').val(result.data[0].isLogin);

					// if (result.data[0].isLogin === '' || result.data[0].isLogin === 'N') {
					//     goLogin();
					//     return;
					// }

					if (_ownProdList.length === 0) {
						// 보유제품이 없는 경우 보유제품 등록 이동 팝업
						var pop = $('#KRP0007200_modalpop02');
						pop.addClass("new-max-width");
						setTimeout(function() {
							pop.vcModal('show');
						}, 100);
					} else if (_ownProdList.length === 1) {
						callOwnModel(0);
					} else {
						openOwnModelList();
					}
				},
				error:function() {
					console.log('실패');
				}
			});

		} else if (_ownProdList.length === 1) {
			callOwnModel(0);
		} else {
			openOwnModelList();
		}
	});

	// 보유제품 선택결과 호출하기
	var callOwnModel = function(idx) {
		var idx = idx || 0;
		setTimeout(function() {
			$('.own_sortview input#ownchk').data('checked', 'true');
			$('.own_sortview input#ownchk').prop('checked', true);

			$('.check-item input#ownchk_m').data('checked', 'true');
			$('.check-item input#ownchk_m').prop('checked', true);
		}, 100);

		$('.hidden-input-group input[name=myOwnModelCode]').val(_ownProdList[idx].modelCode);

		var reselect = $('.product-list-reselect');
		reselect.find('.reselect-left strong').text(_ownProdList[idx].modelDisplayName.replace(/(<([^>]+)>)/gi, ""));
		reselect.find('.reselect-left span').text(_ownProdList[idx].modelCode);

		if (_ownProdList.length > 1) {
			reselect.find('.reselect-right').show();
		} else {
			reselect.find('.reselect-right').hide();
		}

		reselect.show();

		// 재검색
		$('.hidden-input-group input[name=page]').val('1');
		$(window).trigger('plpFilter.change');
	};

	// 보유제품 목록 오픈
	var openOwnModelList = function() {
		var pop = $('#KRP0007200_modalpop01');
		var lis = '';
		_ownProdList.forEach((item, index) => {
			lis += '<li>';
			lis += '    <a href="#n" data-model-code="' + item.modelCode + '" data-index="' + index + '">';
			lis += '        <img src="' + item.imageAddr + '" alt="' + item.modelDisplayName.replace(/(<([^>]+)>)/gi, "") + '" onError="lgkorUI.addImgErrorEvent(this);">';
			lis += '        <span class="haveprod_cnt">';
			lis += '            <span class="cnt_cata">' + item.categoryName +'</span>';
			lis += '            <span class="cnt_name">';
			lis += '                <span class="main">' + item.modelDisplayName + '</span>';
			if (item.keywdNm && item.keywdNm !== '') {
				var keywdNms = item.keywdNm.split('^');
				lis += '                <span class="sub-text-new">';
				lis += '                    <em class="sub">' + keywdNms[0] + '</em>';
				if (keywdNms.length > 1) {
					lis += '                    <em class="sub">' + keywdNms[1] + '</em>';
				}
				lis += '                </span>';
			}
			lis += '            </span>';
			lis += '            <span class="cnt_model">' + item.consumableModelName + '</span>';
			lis += '        </span>';
			lis += '    </a>';
			lis += '</li>';
		});

		pop.find('section.pop-conts ul.haveprod_list').html(lis);

		pop.addClass("new-max-width");
		setTimeout(function() {
			// 선택한 상품이 있으면 나의 보유제품 소모품만 보기 체크 유지
			var dataChecked = $('.product-list-reselect').css('display') === 'block' ? 'true' : 'false';
			var propChecked = $('.product-list-reselect').css('display') === 'block';

			$('.own_sortview input#ownchk').data('checked', dataChecked);
			$('.own_sortview input#ownchk').prop('checked', propChecked);

			$('.check-item input#ownchk_m').data('checked', dataChecked);
			$('.check-item input#ownchk_m').prop('checked', propChecked);

			pop.vcModal('show');
		}, 100);
	};

	// 보유제품 팝업 > 등록 버튼 클릭
	$(document).on("click", "#KRP0007200_modalpop02 .btn-group .btn.pink", function() {
		var registerLink = $('.component.KRP0007.re22').data('myproduct-register-url');
		location.href = registerLink;
	});

	// 보유제품 선택 클릭
	$(document).on('click', '#KRP0007200_modalpop01 section li a', function() {
		var that = $(this);
		var idx = that.data('index');

		var pop = $('#KRP0007200_modalpop01');
		pop.vcModal('close');

		callOwnModel(idx);
	});

	// 보유제품 재선택 클릭
	$(document).on('click', '.reselect-right', function() {
		openOwnModelList();
	});

	$unitList.on('click', '.pagination a, .pagination .page_num a', function(e) {
		e.preventDefault();

		var val = $(this).attr('value')
		if (val === undefined || val === '') {
			return;
		}

		$('.hidden-input-group input[name=page]').val($(this).attr('value'));		
		getPlpUnitList(getAllParam(), true);

	});

	$unitList.on('click', '.card-list-more button', function(e) {
		e.preventDefault();

		var page = $('.hidden-input-group input[name=page]').val();
		$('.hidden-input-group input[name=page]').val(page === '' ? 2 : ++page);

		$('.card-list-more').remove();
		getPlpUnitList(getAllParam());
	});

	var isLock = false;

	$(document).on('plpfilter.lock', function() {
		isLock = true;
	});

	$(document).on('plpfilter.unlock', function() {
		isLock = false;
	});

	// 상품 조회
	function getPlpUnitList(param, isGoScrollToProductList) {
		if (isLock) {
			return;
		}

		var urlSearch = new URLSearchParams(location.search);
		var useJson = false;
		if (urlSearch.has('useJson') && urlSearch.get('useJson') === 'Y') {
			useJson = true;
		}

		//console.log('1.' + useJson);

		isGoScrollToProductList = isGoScrollToProductList || false;

		isLock = true;

		preventFilterClick();	// 필터 영역 클릭 방지
		cateActIntoView(); // 탭 활성화로 가로 스크롤 이동 // BTOCSITE-64954

		var defaultUrl = vcui.isEmpty(lgkorUI.getHiddenInputData().defaultUrl) ? "" : lgkorUI.getHiddenInputData().defaultUrl;
		var ajaxUrl = '/item' + defaultUrl + (useJson ? '/jsonPlpUnitList.lgajax' : '/plpUnitList.lgajax');
		// BTOCSITE-58721 PLP 키오스크 대응 START
		var locationSearch = window.location.search.replaceAll('?', '').split('&').filter(a => a.indexOf('subCateId=') === -1 && a.indexOf('main=')).join('&');
		if (locationSearch !== '') {
			ajaxUrl += (ajaxUrl.indexOf('?') > -1 ? '&' : '?') + locationSearch;
		}
		// BTOCSITE-58721 PLP 키오스크 대응 START

		$.post(ajaxUrl, param).done(function(data) {
			if (isErrorPage(data, true)) {
				isLock = false;
				return;
			}

			//console.log('2.' + useJson);

			if (!useJson) {
				if (vcui.detect.isMobileDevice) {
					// 모바일인 경우
					if (param.page === '' || param.page === '1') {
						$('.product-card-list .product-list-area').html(data);
					} else {
						$('.product-card-list .product-list-area').append(data);
					}
				} else {
					// PC 인 경우
					$('.product-card-list .product-list-area').html(data);
				}
			} else {
				rebuildProductByJsonData(data, param);
			}

            //BTOCSITE-61181 금액 요소 레이아웃 덜렁거림 수정
			var $itemBottom = $('.product-card-list .product-list-area .item-bottom');
			var $middleInfoInner = $('.product-card-list .product-list-area .middle-info-inner');
			$itemBottom.css('visibility','hidden');
			$middleInfoInner.css('visibility','hidden');
			setTimeout(function(){
				$itemBottom.css('visibility','visible');
				$middleInfoInner.css('visibility','visible');
			},200);
            ////BTOCSITE-61181 금액 요소 레이아웃 덜렁거림 수정

			if (isGoScrollToProductList) {
				goScrollToProductList();
			}

			allowFilterClick();	// 필터 영역 클릭 방지 해제

			setTimeDeal(); // BTOCSITE-49751

			initCompare();
			initOptionSwiper();

			unitTypeSliderWidthCheck();

			requestUserWishList();

            $(".ui_tooltip-target").vcTooltipTarget(); // 임직원 & 복지몰 툴팁 초기화

			setTimeout(function() {
				listItemSizeCheck();
				$(document).trigger('filterMovementEvent.reset');
			}, 50);

			isLock = false;
		}).fail(function(e) {
			console.log(e);
			isLock = false;
		});
	}
	
	// ajax 응답페이지 error 페이지인지 확인 후 메시지 노출
	var isErrorPage = function(ajaxHtml, showsErrorMsg) {
		var $html = $(ajaxHtml);
		var hasError = $(ajaxHtml).find('.contents.error-page .error-inner').length;
		if (hasError && showsErrorMsg) {
			// msg 노출
			$(window).trigger("toastshow", $html.find('.contents.error-page .error-inner').find('.tit').text());
		}
		
		return hasError ? true : false;
	}
	

	// 클릭금지
	var preventFilterClick = function() {
		//console.log('클릭 금지 시작');
		defFilterClick('none');
	}

	// 클릭허용
	var allowFilterClick = function() {
		//console.log('클릭 금지 해제');
		defFilterClick('auto');
	}

	// 클릭 방지 대상 정의
	var defFilterClick = function(behavior) {
		$('.plp-filter-wrap label, .plp-filter-wrap input').css('pointer-events', behavior);	// 필터
		$('.range-wrap.range-wrap-new').css('pointer-events', behavior);		// 필터 가격 range
		$('.sort-area.is-select-content select').css('pointer-events', behavior);	// 정렬
		$('.lay-filter-con-plp button').css('pointer-events', behavior);	// 필터 히스토리
		$('.cate-list label, .cate-list input').css('pointer-events', behavior);		// 카테고리탭
		$('.plp-new-section.category-list.pc a').css('pointer-events', behavior);	// 라인업 pc
		$('.plp-new-section.smart-lineup a').css('pointer-events', behavior);	// 스마트홈 라인업
		$('.plp-new-section.category-list.mo a').css('pointer-events', behavior);	// 라인업 mo
		$('.pagination a').css('pointer-events', behavior);	// 페이징 영역
		$('.choice-filter-wrap button').css('pointer-events', behavior);	// 퀵필터
		$('.choice-item .item-reset button').css('pointer-events', behavior);	// 퀵필터 reset
		$('.filter-bottom button, .card-list-none button').css('pointer-events', behavior);	// 필터 초기화
		$('.card-list-more button').css('pointer-events', behavior);	// 카드 more
	}

	// 아이템 수 변경 처리
	$(window).on('plpModelUnit.count.change', function(e) {
		e.preventDefault();
		var plpCountContent = $('.list-sorting .list-count em');
		var plpCountContentM = $('.list-count-mobile .count');
		var plpListItemCount = $('.hidden-input-group input[name=totalCount]').val();
		if(plpCountContent) {
			plpCountContent.text(plpListItemCount);
		}
		if(plpCountContent) {
			plpCountContentM.text(plpListItemCount);
		}

		var plpFilterCountM = $('.filter-bottom .btn-group a.btn span');
		if (plpFilterCountM) {
			plpFilterCountM.html(plpListItemCount + '개 상품보기');
		}

	});

	// 필터(컬러칩 포함) 클릭, category tab 제외
	$(document).on('change', '.chk-wrap input:not(#ownchk), .rdo-wrap input, .type-colorchip .chk-wrap-colorchip input', function() {
		if ($(this).attr('name') === 'sub_category_tab' || $(this).attr('name') === 'sub_category_tab_mo') {
			return;
		}

		//console.log($(this).attr('name') + 'filter changed!!!!');

		if ($(this).attr('name') === 'chk_sort') {
			$('.hidden-input-group input[name=sortType]').val($(this).data('code-id'));
		}

		var filterId = $(this).attr('id');
		var quickFilter = $('#quick_' + filterId);

		// 퀵필터가 존재하면 동기처리
		if (quickFilter.length > 0) {
			if (quickFilter.prop('tagName').toUpperCase() === 'INPUT') {
				quickFilter.prop('checked', $(this).prop('checked'));
			} else if (quickFilter.prop('tagName').toUpperCase() === 'BUTTON') {
				if ($(this).prop('checked')) {
					quickFilter.addClass('on');
				} else {
					quickFilter.removeClass('on');
				}
			}
		}

		// 퀵필터 초기화 버튼 노출
		quickFilterInitBtn();

		$(window).trigger('plpFilter.change');

		// 임직원/복지몰 할인제품 선택시 가격필터 변경
		if ($(this).attr('name') === 'chk_lgeMemberFlag' && $("#priceRangeData").length > 0 ) {
			if ($('.chk-wrap input[name=chk_lgeMemberFlag]').is(':checked')) {
				$("#priceRangeData").html( $("#partnerPriceRange").html() );
			} else {
				$("#priceRangeData").html( $("#b2cPriceRange").html() );
			}
			$(document).trigger('plpFilter.price.reset'); // 필터 이벤트 설정
		}
	});

	// 가격 필터 변경
	var priceSliderCheck = function() {
		$(".ui_filter_slider").on("rangesliderchanged", function () {
			//console.log('filter slide changed!!');

			var selMinPrice = $('.range-wrap p.min').text().replaceAll(',', '').replaceAll('원', '').replaceAll('Min', '0');
			var selMaxPrice = $('.range-wrap p.max').text().replaceAll(',', '').replaceAll('원', '').replaceAll('Max', '0');

			//console.log(selMinPrice + ', ' + selMaxPrice);

			var minPrice = $('.ui_filter_slider').data('min-price');
			var maxPrice = $('.ui_filter_slider').data('max-price');

			if (selMinPrice == '0' && selMaxPrice == '0' ||  selMinPrice == minPrice && selMaxPrice == maxPrice) {
				$('.hidden-input-group input[name=minPrice]').val('');
				$('.hidden-input-group input[name=maxPrice]').val('');
			} else {
				$('.hidden-input-group input[name=minPrice]').val(selMinPrice);
				$('.hidden-input-group input[name=maxPrice]').val(selMaxPrice);
			}

			$(window).trigger('plpFilter.change');
		});
	}

	priceSliderCheck();

	$(document).on('plpFilter.price.reset', function() {
		priceSliderCheck();
	});

	// 탑필터 삭제, 초기화 클릭시
	$(document).on('click', '.s-fliter button.btn-del, .lay-filter-con-plp .btn-refresh, .filter-bottom .btn-group button.btn-refresh', function() {
		//console.log('filter 초기화');

		if ($('.product-card-list').find('li.is-num-slider').length == 0) { // BTOCSITE-62456 [선감지][모니터링 G] 가전구독 전자레인지 필터 적용되지 않는 현상
			$('.hidden-input-group input[name=minPrice]').val('');
			$('.hidden-input-group input[name=maxPrice]').val('');
		}	

		$('.chk-wrap input:not(#ownchk), .rdo-wrap input').each(function(index, target) {
			var filterId = $(target).attr('id');
			var quickFilter = $('#quick_' + filterId);

			// 퀵필터가 존재하면 동기처리
			if (quickFilter.length > 0) {
				if (quickFilter.prop('tagName').toUpperCase() === 'INPUT') {
					quickFilter.prop('checked', $(target).prop('checked'));
				} else if (quickFilter.prop('tagName').toUpperCase() === 'BUTTON') {
					if ($(target).prop('checked')) {
						quickFilter.addClass('on');
					} else {
						quickFilter.removeClass('on');
					}
				}

				//BTOCSITE-56673 , BTOCSITE-56666 - 퀵필터 새로 고침시 추가된 필터는 삭제 처리
				if($(quickFilter).data('btnAddYn') !='' && $(quickFilter).data('btnAddYn') === 'Y'){
					$(quickFilter).closest('li').remove();
					var liCnt = $('.choice-filter-list.swiper-wrapper .swiper-slide').length;
					if(liCnt < 1){
						$('.plp-afilter-inner .choice-base').css({display : 'block'});
					}
				}

			}
		});

		// 퀵필터 초기화 버튼 노출
		//quickFilterInitBtn(); // 'plpFilter.change > getAllParam() 에 quickFilterInitBtn() 실행되어 주석 처리(20240129)

		$(window).trigger('plpFilter.change');
	});

	// 정렬순서 변경 - BTOCSITE-55480 - 정렬 스티키 적용 테스트 수정(20240222)
	$(document).on('change', '.product-list-top .sort-select-wrap select', function(e) {
		//console.log('______정렬순서 변경 pc');
		//수정
		$('.hidden-input-group input[name=sortType]').val($('.product-list-top .sort-select-wrap select option:selected').val());

		$(window).trigger('plpFilter.change');
	});

	//BTOCSITE-55480 - 정렬 스티키 적용 테스트 수정(20240222)
	$(document).on('change', '.list-count-mobile .sort-select-wrap select', function(e) {
		//console.log('_______정렬순서 변경 모바일');
		$('.hidden-input-group input[name=sortType]').val($('.list-count-mobile .sort-select-wrap select option:selected').val());
		$('.hidden-input-group input[name=sortTypeMobile]').val('Y');

		$(window).trigger('plpFilter.change');
	});

	// 필터 변경
	$(window).on('plpFilter.change', function(e) {
		e.preventDefault();
		$('.hidden-input-group input[name=page]').val('1');
		
		getPlpUnitList(getAllParam());
		//console.log('plpFilter.changed !!!');
	});

	// 모바일 다품목할인, 내일배송, 임직원 할인제품 클릭
	$(document).on('click', '.list-sorting .check-item input:not(#ownchk_m)', function() {
		var filterId = $(this).attr('id').replaceAll('quick_', '');
		$('#' + filterId).trigger('click');

		// 퀵필터 초기화 버튼 노출
		quickFilterInitBtn();
	});

	// 모바일 퀵필터 클릭
	$(document).on('click', '.choice-filter-list.swiper-wrapper li.swiper-slide button', function() {
		var hasOn = $(this).hasClass('on');
		//$('.choice-filter-list.swiper-wrapper button').removeClass('on');

		if (!hasOn) {
			$(this).addClass('on');
		} else {
			$(this).removeClass('on');
		}

		// 퀵필터 초기화 버튼 노출
		quickFilterInitBtn();

		// BTOCSITE-56666 PLP화면에서 필터 선택시 퀵필터에 추가되지 않는 현상

		var filterId = $(this).attr('id').replaceAll('quick_', '');
		$('#' + filterId).trigger('click');

		var btnAddYn = $(this).data('btnAddYn');
		if(btnAddYn && btnAddYn == 'Y'){
			//debugger;
			if(filterId.indexOf('product_') < 0){
				$('#'+$(this).attr('id')).closest('li').remove();
			}else{
				$('#quick_chk_product_'+$(this).data('attrId')+'_'+$(this).data('keywdId')).closest('li').remove();
			}

			var liCnt = $('.choice-filter-list.swiper-wrapper .swiper-slide').length;
			if(liCnt < 1){
				$('.plp-afilter-inner .choice-base').css({display : 'block'});
			}
		}

	});

	//BTOCSITE-55480 노트북 PLP 추가 - 다중 필터 추가
	$(document).on('click', '.choice-filter-list li.swiper-slide2 button', function() {
		var hasOn = $(this).hasClass('on');

		if (!hasOn) {
			$(this).addClass('on');
		} else {
			$(this).removeClass('on');
		}

		//console.log('hasOn : ' , hasOn);

		// 퀵필터 초기화 버튼 노출
		quickFilterInitBtn();

		// BTOCSITE-56666 PLP화면에서 필터 선택시 퀵필터에 추가되지 않는 현상
		var filterId = $(this).attr('id').replaceAll('quick_', '');
		$('#' + filterId).trigger('click');

		console.log('_______ KRP0007-3.0.0.js > filterId' , filterId );
	});

	// 퀵필터 초기화 버튼 노출
	var quickFilterInitBtn = function() {

		var filterCountArea = $('.cate-wrap .afilter-btn-area span.filter-count');
		var filterCountAreaCnt = 0;

		if(filterCountArea.text() !=''){
			filterCountAreaCnt = parseInt(filterCountArea.text());
		}

		//1. 퀵필터 밖 속성 목록
		//2. KRP0007.jsp > 나의 보유제품 소모품만 보기 제외가 checked 일때
		if (($('.choice-filter-list.swiper-wrapper button.on').length + $('.list-sorting .check-item input:not(#ownchk_m):checked').length) > 0) {
			$('.plp-afilter-inner .item-reset').show();
		}else if (filterCountAreaCnt > 0){
			$('.plp-afilter-inner .item-reset').show(); //퀵 필터 체크시 초기화 버튼 노출 처리
		}else {
			$('.plp-afilter-inner .item-reset').hide();
		}
		choiseFilterSwiperEvent();	// BTOCSITE-77995 가전구독 슈케어 필터 좌우 스와이프 미작동
	};

	// 모바일 퀵필터 초기화
	$(document).on('click', '.plp-afilter-inner .item-reset button', function() {
		$('.choice-filter-list.swiper-wrapper li.swiper-slide button').removeClass('on');
		$('.list-sorting .check-item input').prop('checked', false);
		$(".lay-filter-con-plp-inner").find(".s-filter-list").find("li").not(".clear-all").remove();
		$(".chk-wrap input, .rdo-wrap input, .type-colorchip .chk-wrap-colorchip input").prop('checked', false);

		$('.hidden-input-group input[name=minPrice]').val('');
		$('.hidden-input-group input[name=maxPrice]').val('');

		// 퀵필터 초기화 버튼 노출
		// BTOCSITE-56673 초기화 수정 - btn-refresh 트리거 실행시 해당 메서드 수행 됨 중복 수행 방지(20240129)
		//quickFilterInitBtn();
		//$(window).trigger('plpFilter.change');

		$('.btn-refresh').trigger('click');
	});

	// view타입 클릭시 hidden값 저장
	$(document).on('click', '.grid-change-cont button', function() {
	});

	// 핕러 기본 파리미터 생성
	var getDefaultParam = function() {
		var param = {
			bizType: $('.hidden-input-group input[name=bizType]').val(),
			superCategoryId: $('.hidden-input-group input[name=superCategoryId]').val(),
			categoryId: $('.hidden-input-group input[name=categoryId]').val(),
			subCategoryId: $('.hidden-input-group input[name=subCategoryId]').val(),
			page: $('.hidden-input-group input[name=page]').val(),
			sortType: $('.hidden-input-group input[name=sortType]').val(),
			viewType: $('.hidden-input-group input[name=viewType]').val(),
			redrawFilterFlag: $('.hidden-input-group input[name=redrawFilterFlag]').val(),
			pageUrl: $('.hidden-input-group input[name=pageUrl]').val()
		};

		if ($('.hidden-input-group input[name=myOwnModelCode]').val() !== '') {
			param.myOwnModelCode = $('.hidden-input-group input[name=myOwnModelCode]').val();
		}

		if ($('.hidden-input-group input[name=lineupId]').val() !== '') {
			param.lineupId = $('.hidden-input-group input[name=lineupId]').val();
		}

		param.viewType = $('.grid-change-cont button').hasClass('twin-type') ? 'twin-type' : 'list-type';

		return param;
	};

	// 필터 전체 파라미터 생성
	var getAllParam = function() {
		var param = getDefaultParam();

		var searchFilterFlag = '';

		// 정렬 필터 적용
		var sortType = $('.hidden-input-group input[name=sortType]').val();
		if (sortType === '') {
			sortType = 'sort_pick';
		}

		//BTOCSITE-55480 - 정렬 스티키 적용 테스트 수정(20240222)
		var sortTypeMobile = $('.hidden-input-group input[name=sortTypeMobile]').val();
		var deviceClassType = ".product-list-top .sort-list .sort-select-wrap";
		if(sortTypeMobile == 'Y'){
			//deviceClassType = ".sort-select-wrap-mobile";
			//console.log('___________sortTypeMobile : ' , sortTypeMobile);
			deviceClassType = ".list-count-mobile .sort-list .sort-select-wrap";
		}

		$('.product-card-list '+deviceClassType+' select option').each(function(index, item) {
			if (sortType === $(item).attr('value')) {
				$(item).prop('selected', true);
				$('.product-card-list .ui-selectbox-view span.ui-select-text').text($(item).text());
			}
		});

		// 다품목할인
		if ($('.chk-wrap input[name=chk_mltpModelYn]').is(':checked')) {
			param.mltpModelYn = 'Y';
		}

		// 모바일 다품목할인
		if ($('.list-sorting .check-item input[name=chk_mltpModelYn_m]').is(':checked')) {
			param.mltpModelYn = 'Y';
		}

		// BTOCSITE-61037 가전구독 PLP내 UP가전 2.0 필터 제공 START
		// UP가전 2.0
		if ($('.chk-wrap input[name=chk_upApplianceFlag]').is(':checked')) {
			param.upApplianceYn = 'Y';
		}
		// BTOCSITE-61037 가전구독 PLP내 UP가전 2.0 필터 제공 END

		// 내일배송
		if ($('.chk-wrap input[name=chk_tomorrowDeliveryFlag]').is(':checked')) {
			param.tomorrowDeliveryFlag = 'Y';
		}

		// 모바일 내일배송
		if ($('.list-sorting .check-item input[name=chk_tomorrowDeliveryFlag_m]').is(':checked')) {
			param.tomorrowDeliveryFlag = 'Y';
		}

		// 닷컴 ONLY
		if ($('.chk-wrap input[name=chk_lgecomOnlyFlag]').is(':checked')) {
			param.lgecomOnlyFlag = 'Y';
		}

		// 임직원/복지몰 할인 제품
		if ($('.chk-wrap input[name=chk_lgeMemberFlag]').is(':checked')) {
			param.lgeMemberFlag = $('.chk-wrap input[name=chk_lgeMemberFlag]').val();
		}

		// 태그 필터 조회 start
		var tagAttrKeywds = [];
		$('.chk-wrap input[name=chk_tag]:checked, .rdo-wrap input[name=chk_tag]:checked').each(function(index, item) {
			tagAttrKeywds.push({
				attrId: $(item).data('attr-id'),
				keywdId: $(item).data('keywd-id'),
				inputModeCode: $(item).data('input-mode-code')
			});
			searchFilterFlag = 'Y';
		});
		param.tagAttrKeywds = JSON.stringify(tagAttrKeywds);
		// 브랜드 필터 조회 end

		// 브랜드 필터 조회 start
		var brandAttrKeywds = [];
		$('.chk-wrap input[name=chk_brand]:checked, .rdo-wrap input[name=chk_brand]:checked').each(function(index, item) {
			brandAttrKeywds.push({
				attrId: $(item).data('attr-id'),
				keywdId: $(item).data('keywd-id'),
				inputModeCode: $(item).data('input-mode-code')
			});
			searchFilterFlag = 'Y';
		});
		param.brandAttrKeywds = JSON.stringify(brandAttrKeywds);
		// 브랜드 필터 조회 end

		// 상품 필터 조회 start
		var productAttrs = [];
		var productNames = [];
		$('.chk-wrap input[name^=chk_product]:checked, .rdo-wrap input[name^=chk_product]:checked').each(function(index, item) {
			productNames.push($(item).attr('name'));
		});

		productNames = Array.from(new Set(productNames));   // 중복 제거
		productNames.forEach(p => {
			var firstP = $('.chk-wrap input[name=' + p + ']:checked, .rdo-wrap input[name=' + p + ']:checked')[0];
			var productAttr = {
				attrId:$(firstP).data('attr-id'),
				inputModeCode:$(firstP).data('input-mode-code'),
				productAttrKeywdList:[]
			};

			//var productAttrKeywdList = '';;
			$('.chk-wrap input[name=' + p + ']:checked, .rdo-wrap input[name=' + p + ']:checked').each(function(index, item) {
				productAttr.productAttrKeywdList.push({
					attrId:$(item).data('attr-id'),
					keywdId:$(item).data('keywd-id'),
					inputModeCode:$(item).data('input-mode-code'),
					parentAttrKeywdMngId:$(item).data('parent-attr-keywd-mng-id'),
					fromValue:$(item).data('from-value'),
					toValue:$(item).data('to-value')
				});
				searchFilterFlag = 'Y';
			});

			productAttrs.push(productAttr);
		});

		param.productAttrs = JSON.stringify(productAttrs);
		// 상품 필터 조회 end

		// 컬러 필터 조회 start
		var colorAttrs = [];
		$('.type-colorchip .chk-wrap-colorchip input[name=chk_color]:checked').each(function(index, item) {
			colorAttrs.push({
				colorLineCode1:$(item).data('color-line-code1')
			});
			searchFilterFlag = 'Y';
		});

		param.colorAttrs = JSON.stringify(colorAttrs);
		// 컬러 필터 조회 end

		// 가격 필터 조회 strat
		var minPrice = $('.hidden-input-group input[name=minPrice]').val();
		var maxPrice = $('.hidden-input-group input[name=maxPrice]').val();
		if (minPrice !== '' && maxPrice !== '') {
			param.minPrice = minPrice;
			param.maxPrice = maxPrice;
		}
		// 가격 필터 조회 end

		// 소모품 sub카테고리 필터 start
		var smallCategoryFilters = [];
		$('.chk-wrap input[name=chk_small_category]:checked').each(function(index, item) {
			smallCategoryFilters.push($(item).data('category-id'));
		});

		param.smallCategoryFilters = JSON.stringify(smallCategoryFilters);
		// 소모품 sub카테고리 필터 end

		// 세트 구성 조회 start
		var setCompAttrs = {};
		var setCompAttrId = '';
		$('.chk-wrap input[name=chk_setComp]:checked, .rdo-wrap input[name=chk_brand]:checked').each(function(index, item) {
			if (index === 0) {
				setCompAttrs = {
					attrId: $(item).data('attr-id'),
					setCompAttrKeywds: []
				};
			}

			setCompAttrs.attrId = $(item).data('attr-id');
			setCompAttrs.setCompAttrKeywds.push({
				attrId:$(item).data('attr-id'),
				keywdId:$(item).data('keywd-id')
			});
			searchFilterFlag = 'Y';
		});

		param.setCompAttrs = JSON.stringify(setCompAttrs);
		// 세트 구성 조회 end
		
		// 뱃지필터 - BTOCSITE-63506 start
		var carePromotionBadges = [];
		$('.chk-wrap input[name=chk_carePromotionBadge]:checked').each(function(index, item) {
			carePromotionBadges.push($(item).val());
			searchFilterFlag = 'Y';
		});
		param.carePromotionBadges = JSON.stringify(carePromotionBadges);
		// 뱃지필터 - BTOCSITE-63506 end

		if (searchFilterFlag === 'Y') {
			param.searchFilterFlag = searchFilterFlag;
		}

		// 모바일 필터 메뉴 버튼 필터수 노출 처리 s
		var filterCnt = $('.lay-filter-con-plp ul.s-filter-list li:not(.clear-all)').length;
		if (filterCnt > 100) {
			filterCnt = 99;
		}

		var filterCountArea = $('.cate-wrap .afilter-btn-area span.filter-count');
		var filterCountArea2 = $('.list-sorting-outter .afilter-btn-area span.filter-count');

		if (filterCnt === 0) {
			filterCountArea.text(0);
			filterCountArea.hide();

			filterCountArea2.text(0);
			filterCountArea2.hide();

		} else {
			filterCountArea.text(filterCnt);
			filterCountArea.show();

			filterCountArea2.text(filterCnt);
			filterCountArea2.show();
		}

		quickFilterInitBtn();

		// 모바일 필터 메뉴 버튼 필터수 노출 처리 e

		var selectedFilters = [];
		// 선택한 필터
		$(".lay-filter-con-plp-inner").find(".s-filter-list").find("li").not(".clear-all").each(function(index, f) {
			var className = $(f).attr('class');
			var titleName = $(f).find('div>span').text();
			if (className === 'is-num-slider') {
				var _priceFilter = $('.ui_filter_slider.ui_price_slider.ui-range-slider');
				
				// price:rangeMinIndex:rangeMaxIndex:minPrice:maxPrice
				if (_priceFilter.attr('data-min') !== undefined && _priceFilter.attr('data-max') !== undefined) {
					selectedFilters.push('price:' + _priceFilter.attr('data-min') + ':' + _priceFilter.attr('data-max') + ':' + $('.hidden-input-group input[name=minPrice]').val() + ':' + $('.hidden-input-group input[name=maxPrice]').val());
				}
			} else {
				selectedFilters.push(className + '^' + titleName);
			}
		});

		param.selectedFilters = JSON.stringify(selectedFilters);

		return param;
	}

	// 필터 목록 비활성화 처리
	$(window).on('plpFilter.disabled', function() {
		$('.type-colorchip .chk-wrap-colorchip input, .chk-wrap input, .rdo-wrap input').each(function(index, item) {
			var name = $(item).attr('name');
			if (name.indexOf('chk_tag') === 0
				|| name.indexOf('chk_brand') === 0
				|| name.indexOf('chk_product') === 0
				|| name.indexOf('chk_color') === 0
				|| name.indexOf('chk_small_category') === 0
				|| name.indexOf('chk_setComp') === 0
			) {
				//console.log($(item).attr('id'));
				//console.log($(item).attr('id') + ':' + _enabledFilters.filter(f => f === $(item).attr('id')).length);
				$(item).attr('disabled', _enabledFilters.filter(f => f === $(item).attr('id')).length === 0);
			}
		});
	});

	// 페이징 draw
	$(window).on('plpModelPaging.draw', function() {
		if (!vcui.detect.isMobileDevice) {
			if (_paging.totalPosts > 0) {
				var pagingHtml = '<a href="javascript:;" class="first ' + (!_paging.isOpenStartPage ? 'disabled' : '') + '" value="' + (_paging.isOpenStartPage ? 1 : '') + '" aria-disabled="false"><span class="blind">처음 페이지 보기</span></a>';
				pagingHtml += '<a href="javascript:;" class="prev ' + (!_paging.hasPrev ? 'disabled' : '') + '" value="' + (_paging.hasPrev ? _paging.prevPage : '') + '" aria-disabled="false"><span class="blind">이전 페이지 보기</span></a>';
				pagingHtml += '<span class="page_num">';
				for (var p = _paging.startPage; p <= _paging.endPage; p++) {
					if (p === _paging.currentPage) {
						pagingHtml += '<strong><span class="blind">현재 페이지</span>' + p + '</strong>';
					} else {
						pagingHtml += '<a href="javascript:;" value="' + p +'" title="' + p + ' 페이지 보기">' + p + '</a>';
					}
				}
				pagingHtml += '</span>';
				pagingHtml += '<a href="javascript:;" class="next ' + (!_paging.hasNext ? 'disabled' : '') + '" value="' + (_paging.hasNext ? _paging.nextPage : '') + '" aria-disabled="false"><span class="blind">다음 페이지 보기</span></a>';
				pagingHtml += '<a href="javascript:;" class="last ' + (!_paging.isOpenEndPage ? 'disabled' : '') + '" value="' + (_paging.isOpenEndPage ? _paging.totalPages : '') + '" aria-disabled="false"><span class="blind">마지막 페이지 보기</span></a>';

				$('.pagination').html(pagingHtml);

				$('.pagination').show();
			} else {
				$('.pagination').hide();
			}
		}
	});

	// 카테고리 탭 클릭
	$(document).on('click', '.cate-list input[name^=sub_category_tab]', function() {
		//var isPushState = isPushState || true;
		
		cateActIntoView(); // 탭 활성화로 가로 스크롤 이동 ( 키보드 포커스 이동 대응 ) // BTOCSITE-60078

		if (isLock) {
			return;
		}

		// 소모품의 경우 해당중카로 이동
		var bizType =  $('.hidden-input-group input[name=bizType]').val();
		if (bizType === 'DISPOSABLE') {
			var categoryUrlPath = $(this).data('category-url-path');
			if (categoryUrlPath !== '') {
				sessionStorage.setItem('isPrevPlpClick', 'true');
				location.href = categoryUrlPath;
			}
			return;
		}

		$('.hidden-input-group input[name=subCategoryId]').val($(this).data('sub-category-id'));
		$('.hidden-input-group input[name=lineupId]').val('');
		$('.hidden-input-group input[name=page]').val(1);
		$('.hidden-input-group input[name=redrawFilterFlag]').val('Y');
		$('.hidden-input-group input[name=pageUrl]').val($(this).data('category-url-path'));		

		var locationSearch = window.location.search.replaceAll('?', '').split('&').filter(a => a.indexOf('subCateId=') === -1 && a.indexOf('main=')).join('&');
		var urlPath = $(this).data('category-url-path');
		if (locationSearch !== '') {
			urlPath += (urlPath.indexOf('?') > -1 ? '&' : '?') + locationSearch;
		}

		window.history.replaceState(null, null, urlPath);

		$('.filter-bottom .btn-group .btn-refresh').trigger('click');

		$(window).trigger('catetabchange',$(this).data('sub-category-id'));
	});
	
	// 옵션 클릭
	var optDataNum = 0;
	$(document).on('click', '.prd-type-cont1 .prd-type-radio input.spec_btn, .prd-type-cont2 .prd-type-radio input.spec_btn', function() {
		var that = $(this);

		var optDispType = that.data('opt-disp-type');

		if(optDispType == 'A' && that.data('org-model-id') === that.data('model-id')) {
			return;
		}

		var targetObj = $('.card-list-item[data-model-id="' + that.data('org-model-id') + '"]');

		var defaultUrl = vcui.isEmpty(lgkorUI.getHiddenInputData().defaultUrl) ? "" : lgkorUI.getHiddenInputData().defaultUrl;
		var ajaxUrl = '/item' + defaultUrl + '/plpUnit.lgajax';
		// BTOCSITE-58721 PLP 키오스크 대응 START
		var locationSearch = window.location.search.replaceAll('?', '').split('&').filter(a => a.indexOf('subCateId=') === -1 && a.indexOf('main=')).join('&');
		if (locationSearch !== '') {
			ajaxUrl += (ajaxUrl.indexOf('?') > -1 ? '&' : '?') + locationSearch;
		}
		// BTOCSITE-58721 PLP 키오스크 대응 START


		var optGrpId = that.data('opt-grp-id');
		var optItemValueTextList= '';
		var optItemValueAttr = [];
		var selectItemValueId = that.data('opt-item-value-id');
		var upCaresolutionYn = that.data('up-caresolution-yn');

		if(optDispType == 'B'){
			$("input[name^="+optGrpId+"-]:checked").each(function(index, item) {
				optItemValueAttr.push($(item).data('opt-item-value-id'));
			});

			optItemValueTextList = optItemValueAttr.join('-');
		}

		var kioskYn = that.data('kiosk-value');

		var param = {
			modelId: that.data('model-id'),
			bizType: $('.hidden-input-group input[name=bizType]').val(),
			categoryId: $('.hidden-input-group input[name=categoryId]').val(),
			optDispType: optDispType,
			optGrpId: that.data('opt-grp-id'),
			optItemValueTextList:optItemValueTextList,
			selectItemValueId: selectItemValueId,
			kioskYn : kioskYn,
			upCaresolutionYn : upCaresolutionYn
		};

		$.post(ajaxUrl, param).done(function(data) {
			if (isErrorPage(data, true)) {
				return;
			}
			optDataNum++;
			var curClass = 'optUniq'+optDataNum;
			var nClassArr = ['first','second','third'];
			var classIdx = -1;
			//var isCol2 = $(".grid-change-bt").hasClass("twin-type")? true : false;
			for(var i=0; i<nClassArr.length; i++){
				if(targetObj.hasClass(nClassArr[i])){
					classIdx = i;
				}
			}
			var dirClass = classIdx != -1 ? nClassArr[classIdx] :'';

			data = data.replace('class="card-list-item normal-card','class="card-list-item normal-card '+dirClass+' '+curClass);
			targetObj.replaceWith(data);

			var $targetObj = $('.'+curClass);
			var $both = $('.'+curClass);

			//var isLeft =  isCol2 ? targetObj.offset().left < 10 : targetObj.offset().left == $('#totalCount').offset().left;
			if(classIdx != -1){
				if(classIdx == 0){
					//console.log('right list객체 높이참조');
					for(var i=0; i<30; i++){
						if($both.next().css('display') != 'none'){
							$both = $both.next();
							break;
						}
					}
				}else{
					//console.log('left list객체 높이참조');
					for(var i=0; i<30; i++){
						if($both.prev().css('display') != 'none'){
							$both = $both.prev();
							break;
						}
					}
				}
			}

			var classNames = [
				'.item-top-badge', '.top-title-main', '.item-middle-prdtype', '.item-timedeal', '.middle-info-inner'
			];
			for(i=0; i < classNames.length; i++){
				var height = Math.max($targetObj.find(classNames[i]).outerHeight(), $both.find(classNames[i]).outerHeight())
				$targetObj.find(classNames[i]).css('height',height);
				$both.find(classNames[i]).css('height',height);
			}

			setTimeDeal(); // BTOCSITE-49751

			initCompare();
			initOptionSwiper('.' + curClass);
			unitTypeSliderWidthCheck(); 
			$(".ui_tooltip-target").vcTooltipTarget(); // 임직원 & 복지몰 툴팁 초기화

			requestUserWishList();

			setTimeout(function() {
				////listItemSizeCheck();
			}, 50);
		}).fail(function(e) {
			console.log(e);
		});
	});
	
	// 가격 레인지 슬라이더 가격 변경 reet
	var resetPriceRangeSlider = function(minIndex, maxIndex) {
		var minIndex = minIndex || 0;
		var maxIndex = maxIndex || 100;
		
		var $rangeSlider = $('.ui-range-slider');
		if (!$rangeSlider.length) {
			return;
		}

		//$rangeSlider.data('range', minIndex + ',' + maxIndex);
		var rangeInstance = $rangeSlider.vcRangeSlider("instance", false);
		rangeInstance.reset(minIndex + ',' + maxIndex);
		$rangeSlider.trigger('rangesliderchanged', {
			minValue: rangeInstance.valuesArr[minIndex], 
			maxValue: rangeInstance.valuesArr[maxIndex]
		});
	}

	// 페이지 접근 제어(신규, 새로고침, 돌아오기)
	$(window).bind('pageshow', function(event) {
		if (window.performance
			&& (window.performance.navigation.type == window.performance.navigation.TYPE_NAVIGATE
				|| window.performance && window.performance.navigation.type == window.performance.navigation.TYPE_RELOAD
			)
		) {
			//removePlpPageInSessionStorage();
			//console.log('새페이지 or 새로고침 : initial session storage');
		} else if (event.persisted || (window.performance && window.performance.navigation.type == window.performance.navigation.TYPE_BACK_FORWARD)) {
			try {
				restorePlpPageFromSessionStorage();
			} catch(e) {
				console.log(e);
				isLock = false;
			}
			
			isLock = false;
		}
	});

	$(window).on("popstate", function(e) {
		/*if (!event.state) {
			return;
		}
		console.log('----------------->' + JSON.stringify(event.state));
		resoterPlpCategoryPage();*/
	});  // 뒤로가기

	// 테스트용
	$(document).on('plpfilter.resotre.session.storge', function() {
		restorePlpPageFromSessionStorage();
	});

	// 상품으로 이동시
	$(document).on('click', '.product-card-list .top-title-main a, .product-card-list .item-middle-thumb a', function() {
		savePlpPageToSessionStorage();
	});
	
	var plpSessionKey = 'plp_v3_data';
		
	// 세션스토리지 저장
	var savePlpPageToSessionStorage = function() {
		
		//var modelId = $(this).closest('.card-list-item').data('model-id');
		//data.modelId = $(this).closest('.card-list-item').data('model-id');

		var selectedFilters = [];
		// 선택한 필터
		$(".lay-filter-con-plp-inner").find(".s-filter-list").find("li").not(".clear-all").each(function(index, f) {
			var className = $(f).attr('class');
			var titleName = $(f).find('div>span').text();
			if (className === 'is-num-slider') {
				var _priceFilter = $('.ui_filter_slider.ui_price_slider.ui-range-slider');

				// price^rangeMinIndex^rangeMaxIndex^minPrice^maxPrice
				if (_priceFilter.attr('data-min') !== undefined && _priceFilter.attr('data-max') !== undefined) {
					selectedFilters.push('price^' + _priceFilter.attr('data-min') + '^' + _priceFilter.attr('data-max') + '^' + $('.hidden-input-group input[name=minPrice]').val() + '^' + $('.hidden-input-group input[name=maxPrice]').val());
				}
			} else {
				selectedFilters.push(className + '^' + titleName);
			}
		});

		var _filterHtml = $('.plp-new-section-product-list .plp-new-section-filter-cont').html();
		var $filter = $(_filterHtml);
		var $priceArea = $('.range-wrap.range-wrap-new', $filter);
		$priceArea.find('div.ui-range-slider-bg').remove();
		$priceArea.find('div.ui-range-slider-range', $filter).remove();
		$priceArea.find('ul.ui-range-slider-value', $filter).remove();
		$priceArea.find('span.ui-range-slider-min', $filter).remove();
		$priceArea.find('span.ui-range-slider-max', $filter).remove();
		$priceArea.find('div.ui_filter_slider.ui_price_slider', $filter).removeClass('ui-range-slider');
		$priceArea.find('div.ui_filter_slider.ui_price_slider', $filter).attr('ui-modules', '');
		$priceArea.find('div.ui_filter_slider.ui_price_slider', $filter).css('-webkit-tap-highlight-color', '');
		$priceArea.find('p.min.range-num', $filter).text('Min');
		$priceArea.find('p.max.range-num', $filter).text('Max');

		var saveData = {
			modelId: $(this).closest('.card-list-item').data('model-id'),
			categoryId: $('.hidden-input-group input[name=categoryId]').val(),
			subCategoryId: $('.hidden-input-group input[name=subCategoryId]').val(),
			lineupId: $('.hidden-input-group input[name=lineupId]').val(),
			sortType: $('.hidden-input-group input[name=sortType]').val(),
			viewType: $('.grid-change-cont button').hasClass('twin-type') ? 'twin-type' : 'list-type',
			ownchkChecked: $('.own_sortview input#ownchk').prop('checked'),
			positionY: window.scrollY || document.documentElement.scrollTop,
			selectedFilters: selectedFilters,
			html: {
				list: $('.product-list-area').html(),
				filter: $filter.prop("outerHTML"),
				choice: $('.component.KRP0007.re22 .cate-m .plp-afilter-choice').html()
			}
		};

		sessionStorage.setItem(plpSessionKey, JSON.stringify(saveData));
	}
	
	var removePlpPageInSessionStorage = function() {
		sessionStorage.removeItem(plpSessionKey);
	}
	
	var resoterPlpCategoryPage = function() {
		return;
		var currentUrlPath =  window.location.pathname + window.location.search;
		$('.cate-list ul.tabs li input').each(function(index, inp) {
			if ($(inp).data('category-url-path') && $(inp).data('category-url-path') === currentUrlPath) {
				$('.hidden-input-group input[name=subCategoryId]').val($(inp).data('sub-category-id'));
				isLock = true;
				$(inp).trigger('click');
				isLock = false;
				//categoryTabClick($(inp),false);
			}
		});

		$('.hidden-input-group input[name=lineupId]').val('');
		$('.hidden-input-group input[name=page]').val(1);
		$('.hidden-input-group input[name=redrawFilterFlag]').val('Y');

		$('.btn-refresh').trigger('click');
	} 
	
	var restorePlpPageFromSessionStorage = function() {
		isLock = true;
		var plpSaveData = JSON.parse(sessionStorage.getItem(plpSessionKey));
		if (!plpSaveData) {
			isLock = false;
			resoterPlpCategoryPage();
			return;
		}
	
		var list = plpSaveData.html.list;
		var choice = plpSaveData.html.choice;
		var filter = plpSaveData.html.filter;
		var categoryId = $('.hidden-input-group input[name=categoryId]').val();
		
		if (!list || !filter || !choice || categoryId !== plpSaveData.categoryId) {
			isLock = false;
			resoterPlpCategoryPage();
			return;
		}

		$('.product-list-area').html(list);
		$('.plp-new-section-product-list .plp-new-section-filter-cont').html(filter);
		$('.component.KRP0007.re22 .cate-m .plp-afilter-choice').html(choice);
				
		// viewType 설정 시작
		var viewType = plpSaveData.viewType || '';
		if (!viewType) {
			viewType = vcui.detect.isMobileDevice ? 'twin-type' : 'list-type';
		}
		
		$('.grid-change-bt').removeClass('twin-type').removeClass('list-type').addClass(viewType);
		$('.plp-new-section-list-cont').removeClass('twin-type').removeClass('list-type').addClass(viewType);
		$('.grid-change-bt i').removeClass('active');
		if (viewType === 'twin-type') {
			$('.grid-change-bt i.twin-ico').addClass('active');
		} else {
			$('.grid-change-bt i.list-ico').addClass('active')
		}
		// viewType 설정 끝		
		
		quickFilterInitBtn(); // 모바일 퀵필터 초기화
		$(document).trigger('filterLayer.init');
		priceSliderCheck();	// 필터 가격 reset
		choiseFilterSwiperEvent();	// 필터 swiper 재 실행

		setTimeDeal(); // BTOCSITE-49751
		initCompare();
		initOptionSwiper();
		unitTypeSliderWidthCheck();
		requestUserWishList();

		setTimeout(function() {
			listItemSizeCheck();
			$(document).trigger('filterMovementEvent.reset');
		}, 50);

		preventFilterClick();

		setTimeout(function() {
			isLock = true;
			try {
				plpSaveData.selectedFilters.reverse().forEach(f => {
					var fs = f.split('^');

					if (!fs) return;

					if (fs[0] === 'price') {
						resetPriceRangeSlider(fs[1] || 0, fs[2] || 100);
					} else {
						$('#' + fs[0]).trigger('click');
					}
				});
			} catch (e) {
				console.log(e);
			} finally {
				isLock = false;	
			}
		}, 50);


		//resetPriceRangeSlider(10, 40);
		allowFilterClick();
		
		//$('.ui_accordion').vcAccordion();	// 필터 accordion 초기화

		removePlpPageInSessionStorage();
		
		window.scrollTo({top:plpSaveData.positionY, left:0, behavior:'auto'});

		var sortType = plpSaveData.sortType || 'sort_pick';

		//BTOCSITE-55480 - 정렬 스티키 적용 테스트 수정(20240222)
		if(vcui.detect.isMobileDevice){
			//console.log('___________________vcui.detect.isMobileDevice Check: ');
			$('.hidden-input-group input[name=sortTypeMobile]').val('Y');
			$('.ui_selectbox#select1-mobile').vcSelectbox('value', sortType, true);
		}else{
			$('.ui_selectbox#select1').vcSelectbox('value', sortType, true);
		}

		var ownchkChecked = plpSaveData.ownchkChecked;
		if (ownchkChecked !== '') {
			$('.own_sortview input#ownchk').data('checked', ownchkChecked ? 'true' : 'false');
			$('.own_sortview input#ownchk').prop('checked', ownchkChecked);
		}
		
		isLock = false;
	}

	// 사업자회원가 보기 클릭
	$(document).on('click', ".is-business-price .btn-box", function(e) {
		e.preventDefault();
		var isLogin = digitalData.hasOwnProperty("userInfo") && digitalData.userInfo.unifyId ? true : false;
		var memberGrp = $(this).data("memberBsnsmbrstat");

		if (!isLogin) {
			$("#sectionLogin").addClass("active");
		} else if(memberGrp == 'W'){
			$("#sectionAuthWait").addClass("active");
		} else {
			$("#sectionAuth").addClass("active");
		}
	});

	// 사업자회원가 보기 popup 버튼 클릭시 처리
	$(document).on("click", ".plp-new-alert-popup button", function(){
		var moveType = $(this).data("moveType");
		var linkUrl = "";
		var linkValue = "";

		if(moveType == 'LOGIN') {
			linkUrl = "/sso/member/login?state=";
			linkValue = location.pathname + location.search;
			location.href = vcui.uri.updateQueryParam(linkUrl,"state", encodeURIComponent(linkValue));
		} else if(moveType == 'AUTH') {
			linkUrl = "/business/registration?state=";
			linkValue = location.pathname + location.search;
			location.href = vcui.uri.updateQueryParam(linkUrl,"state", encodeURIComponent(linkValue));
		} else {
			$(this).parents(".plp-new-alert-popup").removeClass("active");
		}
	});

	$(document).on('click', '.wish-list-button', function(e){
		e.preventDefault();

		if (!$(this).hasClass('active')) {
			$(this).addClass('active');
		} else {
			$(this).removeClass('active');
		}

		var self = this;
    	var target = $(e.currentTarget);
    	var isLogin = digitalData.hasOwnProperty("userInfo") && digitalData.userInfo.unifyId;

    	var loginUrl = "/sso/member/login?state=";
    	var moveUrl = location.pathname + location.search;
    	var ajaxUrl = $('.component.KRP0007').attr("data-wish-api-url");

		if (!isLogin) {
			$(this).removeClass('active');
			lgkorUI.confirm("선택하신 제품을 위시리스트에 담기 위해서는\n" +
				"LG전자 통합 사이트의 로그인이 필요합니다. ", {
				title: "",
				cancelBtnName: "취소",
				okBtnName: "로그인",
				cancel: function () {},
				ok: function () {
					location.href = vcui.uri.updateQueryParam(
						loginUrl,
						"state",
						encodeURIComponent(moveUrl)
					);
				},
			});

			return;
		}

		var wishActive = target.hasClass('active');

		var param = {
			"id": target.data('model-id'),
			"sku": target.data('sku'),
			"categoryId": lgePlpData.pageCategoryId,
			"wishItemId": target.data('wish-item-id'),
			"type": wishActive ? "add" : "remove"
		};

		lgkorUI.requestWish(
			param,
			wishActive,
			function(result) {
				if (result) {
					target.data('wish-item-id', result.wishItemId);
					target.data('wish-list-id', result.wishListId);
					if (wishActive) {
						//BTOCSITE-50417 RTB스크립트 삽입
						(rtbhEvents = window.rtbhEvents || []).push(
							{
								eventType: 'wishlist',
								offerId: target.val()
							},
							{
								eventType: 'uid',
								id: 'unknown'
							});
					}
				}

				requestUserWishList();
			},  // success
			function() {    // fail
				if (!$(this).hasClass('active')) {
					$(this).addClass('active');
				} else {
					$(this).removeClass('active');
				}
			},
			ajaxUrl
		);
	});

	/**
	 * @method markingUserWish
	 * @return {myCallback} [사용자 위시리스트 마킹처리, BTOCSITE-27064, PLP > 제품카드 > 위시리스트 추가]
	 */
	var markingUserWish = function() {
		var plpUserWishList = JSON.parse(sessionStorage['plpUserWishList'] || '[]');

		var userWishTagList = $('button.wish-list-button');

		if (userWishTagList.length === 0) {
			return;
		}

		userWishTagList.each(function(index, itemWishTag) {
			var choiceItemWishTag = plpUserWishList.filter(itemWishUser => itemWishUser.modelId === $(itemWishTag).data('model-id') && itemWishUser.categoryId === lgePlpData.pageCategoryId)[0];

			$(itemWishTag).removeClass('active');

			if (choiceItemWishTag !== undefined) {
				$(itemWishTag).addClass('active');
				$(itemWishTag).data('wish-list-id', choiceItemWishTag.wishListId);
				$(itemWishTag).data('wish-item-id', choiceItemWishTag.wishItemId);
			} else {
				$(itemWishTag).data('wish-list-id', '');
				$(itemWishTag).data('wish-item-id', '');
			}
		});
	}

	/**
	 * @method requestUserWishList
	 * @return {myCallback} [사용자 위시리스트 조회, BTOCSITE-27064, PLP > 제품카드 > 위시리스트 추가]
	 */
	var requestUserWishList = function() {
		var isLogin = digitalData.hasOwnProperty("userInfo") && digitalData.userInfo.unifyId;
		if (!isLogin) {
			sessionStorage.removeItem('plpUserWishList');
			markingUserWish();
			return;
		}

		lgkorUI.requestAjaxDataPost(
			$('.component.KRP0007').attr("data-wish-api-url"),
			{type: 'list'},
			function(result) {
				var itemWishUserList = result.data.data.listData;
				if (itemWishUserList === undefined || itemWishUserList.length === 0) {
					sessionStorage.removeItem('plpUserWishList');
				} else {
					sessionStorage.setItem('plpUserWishList', JSON.stringify(itemWishUserList));
				}

				markingUserWish();
			},
			true,
			true
		);
	}

	requestUserWishList();


	var rebuildProductByJsonData = function(data, param) {
		data.param = param;
		var unitHtml = '';

		if (data.plpModelUnitCnt > 0) {
			var prdData = {...data};
			prdData.param = param;
			delete prdData.plpModelUnitList;
			for (var i = 0; i < data.plpModelUnitList.length; i++) {
				prdData.unit = data.plpModelUnitList[i];

				if (data.bizType === 'PRODUCT' && data.b2cYN === 'Y') {
					unitHtml += getUnitHtml(prdData);
				} else if (data.bizType === 'PRODUCT' && data.b2cYN === 'N') {
					unitHtml += getUnitB2bHtml(prdData);
				} else if (data.bizType === 'DISPOSABLE') {
					unitHtml += getUnitDisposableHtml(prdData);
				} else if (data.bizType === 'CARESOLUTION') {
					unitHtml += getUnitCaresolutionHtml(prdData);
				}
			}
		} else {
			unitHtml = vcui.template(templateUnitNoData, null);
		}

		// html 적용
		if (vcui.detect.isMobileDevice) {
			// 모바일인 경우
			if (param.page === '' || param.page === '1') {
				$('.product-card-list .product-list-area').html(unitHtml);
			} else {
				$('.product-card-list .product-list-area').append(unitHtml);
			}
		} else {
			// PC 인 경우
			$('.product-card-list .product-list-area').html(unitHtml);
		}

		console.log('drawing!!!!');

		//console.log(unitHtml);
	}

	var getUnitHtml = function(prdData) {
		var templateUnit = `
			{{#set showPrice = (unit.modelStatusCode == "ACTIVE" || unit.modelStatusCode == "SOLD_OUT" || (unit.modelStatusCode == "READY_FOR_SALE" && unit.modelSalePlannedPriceDispFlag == "Y")) && unit.obsOriginalPrice > 0 ? "Y" : "N" }}
			<div class="card-list-item normal-card {{#if unit.modelStatusCode == "SOLD_OUT"}}sold-out{{/if}} {{#if showPrice != "Y"}}no-price{{/if}}"
				 role="listitem"
				 data-model-id="{{unit.modelId}}"
				 data-redis-datetime="{{unit.redisEffectiveDatetime}}~{{unit.redisExpirationDatetime}}"
				 data-ec-product='{"model_name" : "{{unit.modelDisplayName.replace('/(<([^>]+)>)/g', '')}}", "model_id" : "{{unit.modelId}}", "model_sku" : "{{unit.sku}}", "model_gubun" : "{{unit.modelGubun}}"
					, "price" : "{{vcui.number.addComma(unit.obsOriginalPrice)}}", "discounted_price" : "{{vcui.number.addComma(unit.obsSellingPrice)}}"
					, "brand" : "{{mktMsg["component-plpBrand"]}}", "category" : "{{unit.superCategoryName}}/{{unit.categoryName}}/{{unit.subCategoryName}}"
					, "ct_id" : "{{unit.subCategoryId == null || unit.subCategoryId == '' ? unit.categoryId : unit.subCategoryId}}"
					, "model_super_category" : "{{unit.superCategoryName}}", "model_category" : "{{unit.categoryName}}", "model_sub_category" : "{{unit.subCategoryName}}", "delivery_badge" : "{{unit.deliveryTomorrowFlag}}"
					, "price_badge" : "{{unit.benefitYn}}", "repurchase_badge" : "N"
					, "model_status" : "{{unit.modelStatusCode}}", "model_page_type" : "PLP", "model_discontinued_date" : "{{unit.modelDiscontinuedDate}}", "install_method" : "", "lgpick_flag" : "{{unit.lgpickFlag}}"
					, "base_price" : "{{vcui.number.addComma(unit.obsOriginalPrice)}}", "is_buynow" : "N", "is_bizmall_item" : "n"}'
			>
				{{# /* 뱃지 START */ #}}
				{{# /* 가격이 없는 케이스일 경우, 해당 normal-card 엘리먼트에 no-price 클래스 추가하는 기능 필요 */ #}}
				<div class="item-top-badge">
					<div class="top-badge-left">
						{{#if unit.modelStatusCode == "READY_FOR_SALE"}}
							<span class="badge red">
								<em>{{mktMsg["component-readyForSale"]}}</em>
							</span>
						{{/if}}
						{{#if unit.modelStatusCode != "READY_FOR_SALE" && unit.releaseDateTxt != "" && unit.releaseDateTxt != null}}
							<span class="badge red">
								<em>{{unit.releaseDateTxt}}</em>
							</span>
						{{/if}}
						{{#if unit.mltpModelYn == "Y"}}
							<span class="badge red">
								<em>다품목할인</em>
							</span>
						{{/if}}
						{{#if unit.couponBadge == "Y"}}
							<span class="badge">
								<em>쿠폰</em>
							</span>
						{{/if}}
						{{#if unit.memberShipPointText != null && unit.memberShipPointText != ""}}
							<span class="badge">
								<em>포인트</em>
							</span>
						{{/if}}
						{{#if unit.giftCashBackText != null && unit.giftCashBackText != ""}}
							<span class="badge">
								<em>사은품</em>
							</span>
						{{/if}}
					</div>
			
					{{#if unit.compareAvailYn == "Y"}}
						<div class="top-badge-right item_compare">
							<a href="javascript:;" role="button" class="comparison chk_compare"
							   data-model-id="{{unit.modelId}}"
							   data-model-name="{{unit.modelName}}"
							   data-model-display-name="{{#raw unit.modelDisplayName}}"
							   data-b2b-cate-mapping="{{unit.b2bCateMapping}}"
							   data-care-type="{{unit.careshipOnlyFlag == "Y" && unit.cTypeCount > 0 ? "C" : "R"}}"
							   data-default-category-id="{{unit.defaultCategoryId}}"
							   data-default-category-name="{{unit.defaultCategoryName}}"
							   title="{{#raw unit.modelDisplayName}}"
							   data-contents="{{#raw unit.modelDisplayName}}"
							>
								<span class="compare_txt">비교하기</span>
							</a>
						</div>
					{{/if}}
				</div>
				{{# /* 뱃지 END */ #}}
				
				{{# /* 제품 정보 START */ #}}
				<div class="item-top">
					<div class="item-top-cont2">
						<div class="top-title-main">
							<a href="{{unit.modelUrlPath}}" data-contents="{{#raw unit.modelDisplayName}}">
								<span class="main-title">
									<span class="main">{{#raw unit.modelDisplayName}}</span>
									{{#if unit.keywdNm != null && unit.keywdNm != ""}}
										<span class="sub-text-new">
											{{#each keywd in unit.keywdNm.split("^")}}
												<em class="sub">{{keywd}}</em>
											{{/each}}
										</span>
									{{/if}}
								</span>
							</a>
						</div>
						<div class="top-title-sub">
							<span class="sub-title">
								<em>{{#raw unit.modelName}}</em>
								{{#if mktConfMap["mkt_plp_main_body_category"].indexOf(unit.categoryId) > -1 && unit.mainBodyModelName != null && unit.mainBodyModelName != ""}} {{# /* BTOCSITE-55986 */ #}}
									<em>(<i>본체 : <a href="/search/result?search={{encodeURIComponent(unit.mainBodyModelName)}}">{{#raw unit.mainBodyModelName}}</a></i>)</em>	
								{{/if}}
							</span>
							{{#if unit.modelReviewDisplayFlag == "Y" && unit.reviewsCount > 0}}
								<div class="rating-cont">
									<span class="rating-score">{{new Number(unit.reviewsScore).toPrecision(2)}}</span>
									<span class="rating-count">
										({{unit.reviewsCount > 9999 ? "9,999+" : vcui.number.addComma(unit.reviewsCount)}})
									</span>
								</div>
							{{/if}}
						</div>
					</div>
				</div>
				
				<div class="item-middle">
					<div class="item-middle-thumb">
						{{#if isLogin == 'Y' && unit.recentlyViewdModelFlag == "Y"}}
							<div class="item-recent">최근 본 제품</div>
						{{/if}}
						<a href="{{unit.modelUrlPath}}" data-contents="{{#raw unit.modelDisplayName}}">  {{# /* BTOCSITE-58721 */ #}}
							{{#if bizType == "PRODUCT" && unit.lgecomOnlyFlag == "Y"}}
								<span class="lge-only right"><em>닷컴<br />ONLY</em></span>
							{{/if}}
							<img src="{{unit.smallImageAddr}}" class="mo" alt="" onError="lgkorUI.addImgErrorEvent(this);">
						</a>
					</div>
			
					<div class="item-middle-prdtype" >
						{{#if unit.optDispType == "A" || unit.optDispType == "B"}}
							{{#set optionGroupsCnt = unit.optionGroups.length}}
							{{#set optionCnt = 0}}
							{{# 
								unit.optionGroups.forEach(optionGroup => {
									optionGroup.options.forEach(option => {
										optionCnt++;
									});
								});
							#}}
						{{/if}}
						{{#if unit.optDispType == "A"}}
							{{#if unit.optModelYn == "Y" && unit.optionGroups != null && unit.optionGroups.length > 0}}
								{{# /* 전체옵션수는 옵션그룹수보다 커야만 함. 같으면 옵션영역 비노출 */ #}}
								{{#if optionGroupsCnt < optionCnt}}
									{{#each optionGroup in unit.optionGroups}}
										{{#if optionGroup.options[0].optItemAttrCode == "01" || optionGroup.options[0].optItemAttrCode == "03"}}
											<div class="swiper prd-type-cont1">
												<div class="swiper-wrapper">
													{{#each option in optionGroup.options}}
														<div class="swiper-slide prd-type-radio">
															<input type="radio" class="spec_btn" name="prd-type-{{unit.modelId}}" 
																   id="prd-type-{{unit.modelId}}-{{option.optItemValueId}}"
																   {{unit.modelId == option.modelId ? "checked" : ""}}
																   {{unit.modelId == null || unit.modelId == '' ? "disabled" : ""}}
																   data-model-id="{{option.modelId}}"
																   data-org-model-id="{{unit.modelId}}"
																   data-opt-disp-type="A"
																   data-opt-grp-id="{{option.optGrpId}}"
																   data-opt-item-value-id="{{option.optItemValueId}}"
																   data-kiosk-value="{{param.kiosk}}"
															>
															<label for="prd-type-{{unit.modelId}}-{{option.optItemValueId}}"><span>{{#raw option.optItemValueNm}}</span></label>
														</div>
													{{/each}}
												</div>
												<div class="item-middle-prdtype-arrow">
													<button class="left">이전</button>
													<button class="right">다음</button>
												</div>
											</div>
										{{#elsif optionGroup.options[0].optItemAttrCode == "02"}}
											{{# /* 컬러칩 */ #}}
											<div class="swiper prd-type-cont2">
												<div class="swiper-wrapper">
													{{#each option in optionGroup.options}}
														<div class="swiper-slide chk-wrap-colorchip prd-type-radio {{option.optItemValueExtraInfo}}">
															<input type="radio" class="spec_btn" name="prd-type-{{unit.modelId}}" 
																   id="prd-type-{{unit.modelId}}-{{option.optItemValueId}}"
																   {{unit.modelId == option.modelId ? "checked" : ""}}
																   {{unit.modelId == null || unit.modelId == '' ? "disabled" : ""}}
																   data-model-id="{{option.modelId}}"
																   data-org-model-id="{{unit.modelId}}"
																   data-opt-disp-type="A"
																   data-opt-grp-id="{{option.optGrpId}}"
																   data-opt-item-value-id="{{option.optItemValueId}}"
																   data-kiosk-value="{{param.kiosk}}"
																   value="{{#raw option.optItemValueId}}"
															>
															<label for="prd-type-{{unit.modelId}}-{{option.optItemValueId}}"><span>{{#raw option.optItemValueNm}}</span></label>
														</div>
													{{/each}}
												</div>
												<div class="item-middle-prdtype-arrow">
													<button class="left">이전</button>
													<button class="right">다음</button>
												</div>
											</div>
										{{/if}}
										{{#if optionGroup.options[0].optItemAttrCode != "01" && optionGroup.options[0].optItemAttrCode != "02" && optionGroup.options[0].optItemAttrCode != "03"}}
											<div class="swiper prd-type-cont1"></div>
										{{/if}}
									{{/each}}
								{{/if}}
							{{/if}}
						{{/if}}
						{{#if unit.optDispType == "B"}}
							{{#if unit.optModelYn == "Y" && unit.optionGroups != null && unit.optionGroups.length > 0}}
								{{# /* 전체옵션수는 옵션그룹수보다 커야만 함. 같으면 옵션영역 비노출 */ #}}
								{{#if optionGroupsCnt < optionCnt}}
									{{#each (optionGroup, optionGroupIndex) in unit.optionGroups}}
										{{#if optionGroup.options[optionGroupIndex].optItemAttrCode == "01" || optionGroup.options[optionGroupIndex].optItemAttrCode == "03"}}
											<div class="swiper prd-type-cont1 swiper-initialized swiper-horizontal swiper-pointer-events swiper-backface-hidden">
												<div class="swiper-wrapper" id="swiper-wrapper-10dfda605b5e9919f" aria-live="polite">
													{{#each (option, optionIndex) in optionGroup.options}}
														<div class="swiper-slide prd-type-radio swiper-slide-active" role="group" aria-label="1 / 2">
															<input type="radio" class="spec_btn" name="{{option.optGrpId}}-{{optionGroupIndex}}" 
																   id="{{option.optGrpId}}-{{optionGroupIndex}}-{{optionIndex}}"
																   {{unit.modelId == option.modelId ? "checked" : ""}}
																   {{unit.modelId == null || unit.modelId == '' ? "disabled" : ""}}
																   data-model-id="{{option.modelId}}"
																   data-org-model-id="{{unit.modelId}}"
																   data-opt-disp-type="B"
																   data-opt-grp-id="{{option.optGrpId}}"
																   data-opt-item-value-id="{{option.optItemValueId}}"
																   data-kiosk-value="{{param.kiosk}}"
															>
															<label for="{{option.optGrpId}}-{{optionGroupIndex}}-{{optionIndex}}"><span>{{#raw option.optItemValueNm}}</span></label>
														</div>
													{{/each}}
												</div>
												<div class="item-middle-prdtype-arrow" style="display: none;">
													<button class="left swiper-button-disabled swiper-button-lock" disabled="" tabindex="-1" aria-label="Previous slide" aria-controls="swiper-wrapper-10dfda605b5e9919f" aria-disabled="true">이전</button>
													<button class="right swiper-button-disabled swiper-button-lock" disabled="" tabindex="-1" aria-label="Next slide" aria-controls="swiper-wrapper-10dfda605b5e9919f" aria-disabled="true">다음</button>
												</div>
												<span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span>
											</div>
										{{#elsif optionGroup.options[optionGroupIndex].optItemAttrCode == "02"}}
											<div class="swiper prd-type-cont2 swiper-initialized swiper-horizontal swiper-pointer-events swiper-backface-hidden">
												<div class="swiper-wrapper" id="swiper-wrapper-f76de7179b091169" aria-live="polite">
													{{#each (option, optionIndex) in optionGroup.options}}
														<div class="swiper-slide chk-wrap-colorchip {{option.optItemValueExtraInfo}} prd-type-radio swiper-slide-active" role="group" aria-label="1 / 2">
															<input type="radio" class="spec_btn" name="{{option.optGrpId}}-{{optionGroupIndex}}" 
																   id="{{option.optGrpId}}-{{optionGroupIndex}}-{{optionIndex}}"
																   {{unit.modelId == option.modelId ? "checked" : ""}}
																   {{unit.modelId == null || unit.modelId == '' ? "disabled" : ""}}
																   data-model-id="{{option.modelId}}"
																   data-org-model-id="{{unit.modelId}}"
																   data-opt-disp-type="B"
																   data-opt-grp-id="{{option.optGrpId}}"
																   data-opt-item-value-id="{{option.optItemValueId}}"
																   data-kiosk-value="{{param.kiosk}}"
																   value="{{option.optItemValueId}}"
															>
															<label for="{{option.optGrpId}}-{{optionGroupIndex}}-{{optionIndex}}"><span>{{#raw option.optItemValueNm}}</span></label>
														</div>
													{{/each}}
												</div>
												<div class="item-middle-prdtype-arrow" style="display: none;">
													<button class="left swiper-button-disabled swiper-button-lock" disabled="" tabindex="-1" aria-label="Previous slide" aria-controls="swiper-wrapper-f76de7179b091169" aria-disabled="true">이전</button>
													<button class="right swiper-button-disabled swiper-button-lock" disabled="" tabindex="-1" aria-label="Next slide" aria-controls="swiper-wrapper-f76de7179b091169" aria-disabled="true">다음</button>
												</div>
												<span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span>
											</div>
										{{/if}}
										{{#if optionGroup.options[optionGroupIndex].optItemAttrCode != "01" && optionGroup.options[optionGroupIndex].optItemAttrCode != "02" && optionGroup.options[optionGroupIndex].optItemAttrCode != "03"}}
											<div class="swiper prd-type-cont1"></div>
										{{/if}}
									{{/each}}
								{{/if}}
							{{/if}}
						{{/if}}
					</div>
				</div>
				
				{{# /* BTOCSITE-49751 [상품] 딜 플랫폼 Start */ #}}
				<div class="item-timedeal {{unit.dealProductModel != null && unit.dealProductModel.isTimeDealSoldOut ? "sold-out" : ""}}">
					{{#if unit.dealProductModel != null}}
						<div class="item-timedeal-cont">
							<div class="item-timedeal-outer">
								<div class="item-timedeal-inner">
									{{#if unit.dealProductModel.isTimeDealSoldOut}}
										<div class="timedeal-time">{{#raw mktMsg["mkt-timeDealSoldOutText"]}}</div>
									{{#else}}
										<div class="timedeal-time" data-end-date="{{unit.dealProductModel.endDate.year.toString() + "-" + unit.dealProductModel.endDate.monthValue.toString().padStart(2, "0") + "-" + unit.dealProductModel.endDate.dayOfMonth.toString().padStart(2, "0") + "T" + unit.dealProductModel.endDate.hour.toString().padStart(2, "0") + ":" + unit.dealProductModel.endDate.minute.toString().padStart(2, "0") + ":" + unit.dealProductModel.endDate.second.toString().padStart(2, "0")}}"></div>
										<div class="timedeal-text">
											<span class="timedeal-count">{{unit.dealProductModel.dealInventoryQty}}</span>개 남음
										</div>
									{{/if}}
								</div>
							</div>
						</div>
					{{/if}}
				</div>
				{{# /* BTOCSITE-49751 [상품] 딜 플랫폼 End */ #}}
				
				<div class="item-middle-info">
					<ul class="middle-info-inner">{{# /* 아이템 카드의 크기 보정을 위해 표시할 정보가 없어도 비어있는 middle-info-inner 엘리먼트가 존재해야 함 */ #}}
						{{#if unit.productAttrKeywds != null && unit.productAttrKeywds.length > 0}}
							{{#each prodAttr in unit.productAttrKeywds}}
								{{#if prodAttr.keywds != null && prodAttr.keywds != ""}}
									<li class="middle-info-list">
										<spagroupn class="info">{{#raw prodAttr.attrNm}}</spagroupn>
										{{#each (keywd, index) in prodAttr.keywds.split("^")}}
											<em class="info point {{index+1 == prodAttr.keywds.split("^").length ? "" : "comma"}}">{{#raw keywd}}</em>
										{{/each}}
									</li>
								{{/if}}
							{{/each}}
						{{/if}}
					</ul>
				</div>
				{{# /* 제품 정보 END */ #}}
				
				{{# /* 구매 정보 START */ #}}
				{{#if param.kiosk != "y"}} {{# /* BTOCSITE-58721 */ #}}
					<div class="item-bottom">
						<div class="item-bottom-price">
							<div class="item-price-cont normal-price"> {{# /* 아이템 카드의 크기 보정을 위해 표시할 정보가 없어도 비어있는 normal-price 엘리먼트가 존재해야 함 */ #}}
								{{#if showPrice == "Y"}}
									<div class="item-price-cont-inner">
										{{#if unit.obsSellingPrice == unit.obsOriginalPrice}}
											<strong class="price"><em>{{vcui.number.addComma(unit.obsOriginalPrice)}}</em>원</strong>
										{{#else}}
											{{#if Math.floor((unit.obsOriginalPrice - unit.obsSellingPrice) / unit.obsOriginalPrice * 100) >= 5}}
												<span class="sale">{{vcui.number.addComma(Math.floor((unit.obsOriginalPrice - unit.obsSellingPrice) / unit.obsOriginalPrice * 100))}}%</span>
											{{/if}}
											<strong class="price"><em>{{vcui.number.addComma(unit.obsSellingPrice)}}</em>원</strong>
											<em class="subtext true-price">{{vcui.number.addComma(unit.obsOriginalPrice)}}원</em>
										{{/if}}
									</div>
								{{/if}}
							</div>
							
							{{# /* 임직원/복지몰 할인가 START */ #}}
							{{# /* BTOCSITE-60019 PLP - 임직원/복지몰 최대혜택가 적용 */ #}}
							<div class="item-price-cont staff-price"> {{# /* 아이템 카드의 크기 보정을 위해 표시할 정보가 없어도 비어있는 staff-price 엘리먼트가 존재해야 함 */ #}}
								{{#if showPrice == "Y" 
								      && unit.partnerGrp != null 
								      && unit.partnerGrp.split(",").filter(a => a == 'AFC' || a == 'AFF' || a == 'LGE').length > 0
								      && unit.dealProductModel != null
								      && bizType == "PRODUCT"
								      && unit.partnerPrice > 0
								      && unit.obsSellingPrice > unit.partnerPrice
								}}
									{{#set staffPriceTitle = unit.empType == "A" ? "임직원할인가" : "복지몰할인가"}}
									<span class="text">{{staffPriceTitle}}</span>
									<div class="tooltip-wrap tooltip-wrap-new">
										<span class="tooltip-icon ui_tooltip-target" ui-modules="TooltipTarget">
											<em class="tooltip-trigger">자세히 보기</em>
										</span>
										<div class="tooltip-box-new">
											<div class="accord-cont ui_accord_content">
												<div class="title">{{staffPriceTitle}}</div>
												<div class="list">
													<ul>
														{{#if unit.empType == "A"}}
															<li>임직원할인가는 LG 임직원에게만 노출되는 가격이며, 할인율은 모델마다 상이할 수 있습니다.</li>
															<li>임직원 할인 잔여한도에 따라 할인금액이 적용되지 않을 수 있으며, 최종 할인 적용 여부는 주문서에서 확인 가능합니다.</li>
															<li>캐시백, 결제일할인 구매 혜택이 있는 제품의 경우 임직원할인가에 추가로 해당 구매 혜택이 반영됩니다. 상세 내용은 구매 혜택 안내에서 확인 가능합니다.</li>
														{{#elsif unit.empType == "B"}}
															<li>복지몰할인가는 LG전자 제휴사 임직원에게만 노출되는 가격이며, 할인율은 모델마다 상이할 수 있습니다.<br/>최종 할인 적용 여부는 주문서에서 확인 가능합니다.</li>
															<li>캐시백, 결제일할인 구매 혜택이 있는 제품의 경우 복지몰할인가에 추가로 해당 구매 혜택이 반영됩니다. 상세 내용은 구매 혜택 안내에서 확인 가능합니다.</li>
														{{/if}}
													</ul>
												</div>
											</div>
											<button type="button" class="btn-close"><span class="blind">닫기</span></button>
										</div>
									</div>
									<span class="price"><em>{{vcui.number.addComma(unit.partnerPrice)}}</em>원</span>
								{{/if}}
							</div>
							{{# /* // BTOCSITE-60019 PLP - 임직원/복지몰 최대혜택가 적용 */ #}}
							{{# /* 임직원/복지몰 할인가 END */ #}}
							
							{{# /* 최대혜택가 START */ #}}
							{{# /* BTOCSITE-60019 PLP - 임직원 최대혜택가 적용 */ #}}
							{{#if unit.modelStatusCode == "ACTIVE" && unit.obsLastBenefitPrice > 0}}
								<div class="item-price-cont max-reward" data-model-url="{{#raw unit.modelUrlPath}}">
									<a href="javascript:void(0);" 
									   data-model-status-code="{{unit.modelStatusCode}}"
									   data-reward-price="{{unit.obsLastBenefitPrice}}"
									   data-original-price="{{unit.obsOriginalPrice}}"
									   data-selling-price="{{unit.obsSellingPrice}}"
									   data-member-discount-price="{{unit.obsMemberDiscountPrice}}"
									   data-extra-discount-price="{{unit.obsExtraDiscountPrice}}"
									   data-coupon-discount-price="{{unit.couponDiscountPrice}}"
									   data-coupon-discount-rate="{{unit.couponDiscountRate}}"
									   data-card-cash-back-price="{{unit.cardCashBackPrice}}"
									   data-appr-date-discount-price="{{unit.apprDateDiscountPrice}}"
									   data-appr-date-discount-rate="{{unit.apprDateDiscountRate}}"
									   data-member-ship-point-text="{{unit.memberShipPointText}}"
									   data-gift-cash-back-text="{{unit.giftCashBackText}}"
									   data-discount-appr-price="{{unit.discountApprPrice}}"
									   data-partner-price="{{unit.partnerPrice}}"
									   data-emp-type="{{unit.empType}}"
									>
										<span class="reward-text">최대혜택가</span>
										<span class="reward-price"><em>{{vcui.number.addComma(unit.obsLastBenefitPrice)}}</em>원</span>
									</a>
								</div>
							{{/if}}
							{{# /* 최대혜택가 END */ #}}
						</div>
						
						{{# /* 내일배송 START */ #}}
						<div class="item-bottom-reward green"> {{# /* 아이템 카드의 크기 보정을 위해 표시할 정보가 없어도 비어있는 item-bottom-reward 엘리먼트가 존재해야 함 */ #}}
							{{# /* BTOCSITE-58615, PLP/검색 내일배송 제거, systemTomorrowDeliveryDisplayFlag:Y 인 경우만 노출처리  */ #}}
							{{# /* 내일배송 로직 추가, 2024/02/07 */ #}}
							{{#if systemTomorrowDeliveryDisplayFlag == "Y" && unit.modelStatusCode == "ACTIVE" && unit.deliveryTomorrowFlag == "Y" && unit.nextDayFlag == "N"}}
								<span>{{unit.deliveryTomorrowText}}</span>
							{{/if}}
						</div>
						<div class="item-bottom-tag"> {{# /* 아이템 카드의 크기 보정을 위해 표시할 정보가 없어도 비어있는 item-bottom-tag 엘리먼트가 존재해야 함 */ #}}
							{{# /* BTOCSITE-58615, PLP/검색 내일배송 제거, systemTomorrowDeliveryDisplayFlag:Y 인 경우만 노출처리 */ #}}
							{{#if systemTomorrowDeliveryDisplayFlag == "Y" && unit.modelStatusCode == "ACTIVE" && unit.deliveryTomorrowFlag == "Y" && unit.nextDayFlag == "Y"}}
								<div class="plp-tooltip-item">
									<button type="button" class="tag tomorrow green">내일배송 ~ 15시 주문 시</button>
									<div class="tooltip-box tomorrow">
										<div class="accord-cont ui_accord_content">
											<div class="title">유의사항</div>
											<div class="list">
												<ul>
													<li>제주도/도서산간지역 및 재고 상황에 따라 변동될 수 있습니다.</li>
													<li>일요일/공휴일/물류 휴무일에는 배송이 되지 않습니다.</li>
													<li>지연배송 발생 시 해당일 오전에 지연 안내 문자가 발송됩니다.</li>
													<li>내일배송은 오후 3시 이전 결제 시 가능합니다.</li>
												</ul>
											</div>
										</div>
										<button type="button" class="btn-close"><span class="blind">닫기</span></button>
									</div>
								</div>
							{{/if}}
				
							{{#if showPrice == "Y" && unit.modelStatusCode == "SOLD_OUT"}}
								<em class="badge-sold-out">일시품절</em>
							{{/if}}
						</div>
						{{# /* 내일배송 END */ #}}

						<div class="item-bottom-bottom">
							<div class="wish-list">
								{{#if unit.modelStatusCode == "ACTIVE" || unit.modelStatusCode == "SOLD_OUT" || unit.modelStatusCode == "READY_FOR_SALE" }}
									<button class="wish-list-button" data-model-id="{{unit.modelId}}" data-sku="{{#raw unit.sku}}">위시리스트</button>
								{{/if}}
							</div>
							{{#if unit.compareAvailYn == "Y"}}
								<div class="comparison-content">
									<button type="button" class="comparison-content-button"
											data-model-id="{{unit.modelId}}"
											data-model-name="{{#raw unit.modelName}}"
											data-model-display-name="{{#raw unit.modelDisplayName}}"
											data-b2b-cate-mapping="{{unit.b2bCateMapping}}"
											data-care-type="{{unit.careshipOnlyFlag == "Y" && unit.cTypeCount > 0 ? "C" : "R"}}"
											data-default-category-id="{{unit.defaultCategoryId}}"
											data-default-category-name="{{#raw unit.defaultCategoryName}}"
											data-contents="{{#raw unit.modelDisplayName}}"
									>
										비교하기
									</button>
								</div>
							{{/if}}
						</div>

					</div>
				{{/if}} {{# /* BTOCSITE-58721 */ #}}
				{{# /* 구매 정보 END */ #}}				
			</div>
		`;

		return vcui.template(templateUnit, prdData);

	}

	var getUnitB2bHtml = function(prdData) {
		var templateUnit = `
			{{#set defaultUrl = vcui.isEmpty(lgkorUI.getHiddenInputData().defaultUrl) ? "" : lgkorUI.getHiddenInputData().defaultUrl }}
			{{#set showPrice = (unit.modelStatusCode == "ACTIVE" || unit.modelStatusCode == "SOLD_OUT" || (unit.modelStatusCode == "READY_FOR_SALE" && unit.modelSalePlannedPriceDispFlag == "Y")) && unit.partnerPrice > 0 ? "Y" : "N" }}
			<div class="card-list-item normal-card {{#if unit.modelStatusCode == "SOLD_OUT"}}sold-out{{/if}} {{#if showPrice != "Y"}}no-price{{/if}}"
				 role="listitem"
				 data-model-id="{{unit.modelId}}"
				 data-redis-datetime="{{unit.redisEffectiveDatetime}}~{{unit.redisExpirationDatetime}}"
				 data-ec-product='{"model_name" : "{{unit.modelDisplayName.replace('/(<([^>]+)>)/g', '')}}", "model_id" : "{{unit.modelId}}", "model_sku" : "{{unit.sku}}", "model_gubun" : "{{unit.modelGubun}}"
					, "price" : "{{vcui.number.addComma(unit.obsOriginalPrice)}}", "discounted_price" : "{{vcui.number.addComma(unit.partnerPrice)}}"
					, "brand" : "{{mktMsg["component-plpBrand"]}}", "category" : "{{unit.superCategoryName}}/{{unit.categoryName}}/{{unit.subCategoryName}}"
					, "ct_id" : "{{unit.subCategoryId == null || unit.subCategoryId == '' ? unit.categoryId : unit.subCategoryId}}"
					, "model_super_category" : "{{unit.superCategoryName}}", "model_category" : "{{unit.categoryName}}", "model_sub_category" : "{{unit.subCategoryName}}", "delivery_badge" : "{{unit.deliveryTomorrowFlag}}"
					, "price_badge" : "{{unit.benefitYn}}", "repurchase_badge" : "N"
					, "model_status" : "{{unit.modelStatusCode}}", "model_page_type" : "PLP", "model_discontinued_date" : "{{unit.modelDiscontinuedDate}}", "install_method" : "", "lgpick_flag" : "{{unit.lgpickFlag}}"
					, "base_price" : "{{vcui.number.addComma(unit.obsOriginalPrice)}}", "is_buynow" : "N", "is_bizmall_item" : "y"}'
			>
				{{# /* 뱃지 START */ #}}
				{{# /* 가격이 없는 케이스일 경우, 해당 normal-card 엘리먼트에 no-price 클래스 추가하는 기능 필요 */ #}}
				<div class="item-top-badge">
					<div class="top-badge-left">
						{{#if unit.modelStatusCode == "READY_FOR_SALE"}}
							<span class="badge red">
								<em>{{mktMsg["component-readyForSale"]}}</em>
							</span>
						{{/if}}
						{{#if unit.modelStatusCode != "READY_FOR_SALE" && unit.releaseDateTxt != "" && unit.releaseDateTxt != null}}
							<span class="badge red">
								<em>{{unit.releaseDateTxt}}</em>
							</span>
						{{/if}}
					</div>
			
					{{#if unit.compareAvailYn == "Y"}}
						<div class="top-badge-right item_compare">
							<a href="javascript:;" role="button" class="comparison chk_compare"
							   data-model-id="{{unit.modelId}}"
							   data-model-name="{{unit.modelName}}"
							   data-model-display-name="{{#raw unit.modelDisplayName}}"
							   data-b2b-cate-mapping="{{unit.b2bCateMapping}}"
							   data-care-type="{{unit.careshipOnlyFlag == "Y" && unit.cTypeCount > 0 ? "C" : "R"}}"
							   data-default-category-id="{{unit.defaultCategoryId}}"
							   data-default-category-name="{{unit.defaultCategoryName}}"
							   title="{{#raw unit.modelDisplayName}}"
							   data-contents="{{#raw unit.modelDisplayName}}"
							>
								<span class="compare_txt">비교하기</span>
							</a>
						</div>
					{{/if}}
				</div>
				{{# /* 뱃지 END */ #}}
				
				{{# /* 제품 정보 START */ #}}
				<div class="item-top">
					<div class="item-top-cont2">
						<div class="top-title-main">
							<a href="{{defaultUrl}}{{unit.modelUrlPath}}" data-contents="{{unit.modelDisplayName}}">
								<span class="main-title">
									<span class="main">{{#raw unit.modelDisplayName}}</span>
									{{#if unit.keywdNm != null && unit.keywdNm != ""}}
										<span class="sub-text-new">
											{{#each keywd in unit.keywdNm.split("^")}}
												<em class="sub">{{keywd}}</em>
											{{/each}}
										</span>
									{{/if}}
								</span>
							</a>
						</div>
						<div class="top-title-sub">
							<span class="sub-title">
								<em>{{#raw unit.modelName}}</em>
								<{{#if mktConfMap["mkt_plp_main_body_category"].indexOf(unit.categoryId) > -1 && unit.mainBodyModelName != null && unit.mainBodyModelName != ""}} {{# /* BTOCSITE-55986 */ #}}
									<em>(<i>본체 : <a href="/search/result?search={{encodeURIComponent(unit.mainBodyModelName)}}">{{#raw unit.mainBodyModelName}}</a></i>)</em>	
								{{/if}}
							</span>
							{{#if unit.modelReviewDisplayFlag == "Y" && unit.reviewsCount > 0}}
								<div class="rating-cont">
									<span class="rating-score">{{new Number(unit.reviewsScore).toPrecision(2)}}</span>
									<span class="rating-count">
										({{unit.reviewsCount > 9999 ? "9,999+" : vcui.number.addComma(unit.reviewsCount)}})
									</span>
								</div>
							{{/if}}
						</div>
					</div>
				</div>
				<div class="item-middle">
					<div class="item-middle-thumb">
						<a href="{{defaultUrl}}{{unit.modelUrlPath}}{{param.kiosk == "y" ? "?kiosk=y" : ""}}" data-contents="{{#raw unit.modelDisplayName}}"> {{# /* BTOCSITE-58721 */ #}}
							<img src="{{unit.smallImageAddr}}" class="mo" alt="" onError="lgkorUI.addImgErrorEvent(this);">
						</a>
					</div>
					<div class="item-middle-prdtype" >
						{{#if unit.optDispType == "A" || unit.optDispType == "B"}}
							{{#set optionGroupsCnt = unit.optionGroups.length}}
							{{#set optionCnt = 0}}
							{{# 
								unit.optionGroups.forEach(optionGroup => {
									optionGroup.options.forEach(option => {
										optionCnt++;
									});
								});
							#}}
						{{/if}}
						{{#if unit.optDispType == "A"}}
							{{#if unit.optModelYn == "Y" && unit.optionGroups != null && unit.optionGroups.length > 0}}
								{{# /* 전체옵션수는 옵션그룹수보다 커야만 함. 같으면 옵션영역 비노출 */ #}}
								{{#if optionGroupsCnt < optionCnt}}
									{{#each optionGroup in unit.optionGroups}}
										{{#if optionGroup.options[0].optItemAttrCode == "01" || optionGroup.options[0].optItemAttrCode == "03"}}
											<div class="swiper prd-type-cont1">
												<div class="swiper-wrapper">
													{{#each option in optionGroup.options}}
														<div class="swiper-slide prd-type-radio">
															<input type="radio" class="spec_btn" name="prd-type-{{unit.modelId}}" 
																   id="prd-type-{{unit.modelId}}-{{option.optItemValueId}}"
																   {{unit.modelId == option.modelId ? "checked" : ""}}
																   {{unit.modelId == null || unit.modelId == '' ? "disabled" : ""}}
																   data-model-id="{{option.modelId}}"
																   data-org-model-id="{{unit.modelId}}"
																   data-opt-disp-type="A"
																   data-opt-grp-id="{{option.optGrpId}}"
																   data-opt-item-value-id="{{option.optItemValueId}}"
																   data-kiosk-value="{{param.kiosk}}"
															>
															<label for="prd-type-{{unit.modelId}}-{{option.optItemValueId}}"><span>{{#raw option.optItemValueNm}}</span></label>
														</div>
													{{/each}}
												</div>
												<div class="item-middle-prdtype-arrow">
													<button class="left">이전</button>
													<button class="right">다음</button>
												</div>
											</div>
										{{#elsif optionGroup.options[0].optItemAttrCode == "02"}}
											{{# /* 컬러칩 */ #}}
											<div class="swiper prd-type-cont2">
												<div class="swiper-wrapper">
													{{#each option in optionGroup.options}}
														<div class="swiper-slide chk-wrap-colorchip prd-type-radio {{option.optItemValueExtraInfo}}">
															<input type="radio" class="spec_btn" name="prd-type-{{unit.modelId}}" 
																   id="prd-type-{{unit.modelId}}-{{option.optItemValueId}}"
																   {{unit.modelId == option.modelId ? "checked" : ""}}
																   {{unit.modelId == null || unit.modelId == '' ? "disabled" : ""}}
																   data-model-id="{{option.modelId}}"
																   data-org-model-id="{{unit.modelId}}"
																   data-opt-disp-type="A"
																   data-opt-grp-id="{{option.optGrpId}}"
																   data-opt-item-value-id="{{option.optItemValueId}}"
																   data-kiosk-value="{{param.kiosk}}"
																   value="{{#raw option.optItemValueId}}"
															>
															<label for="prd-type-{{unit.modelId}}-{{option.optItemValueId}}"><span>{{#raw option.optItemValueNm}}</span></label>
														</div>
													{{/each}}
												</div>
												<div class="item-middle-prdtype-arrow">
													<button class="left">이전</button>
													<button class="right">다음</button>
												</div>
											</div>
										{{/if}}
										{{#if optionGroup.options[0].optItemAttrCode != "01" && optionGroup.options[0].optItemAttrCode != "02" && optionGroup.options[0].optItemAttrCode != "03"}}
											<div class="swiper prd-type-cont1"></div>
										{{/if}}
									{{/each}}
								{{/if}}
							{{/if}}
						{{/if}}
						{{#if unit.optDispType == "B"}}
							{{#if unit.optModelYn == "Y" && unit.optionGroups != null && unit.optionGroups.length > 0}}
								{{# /* 전체옵션수는 옵션그룹수보다 커야만 함. 같으면 옵션영역 비노출 */ #}}
								{{#if optionGroupsCnt < optionCnt}}
									{{#each (optionGroup, optionGroupIndex) in unit.optionGroups}}
										{{#if optionGroup.options[optionGroupIndex].optItemAttrCode == "01" || optionGroup.options[optionGroupIndex].optItemAttrCode == "03"}}
											<div class="swiper prd-type-cont1 swiper-initialized swiper-horizontal swiper-pointer-events swiper-backface-hidden">
												<div class="swiper-wrapper" id="swiper-wrapper-10dfda605b5e9919f" aria-live="polite">
													{{#each (option, optionIndex) in optionGroup.options}}
														<div class="swiper-slide prd-type-radio swiper-slide-active" role="group" aria-label="1 / 2">
															<input type="radio" class="spec_btn" name="{{option.optGrpId}}-{{optionGroupIndex}}" 
																   id="{{option.optGrpId}}-{{optionGroupIndex}}-{{optionIndex}}"
																   {{unit.modelId == option.modelId ? "checked" : ""}}
																   {{unit.modelId == null || unit.modelId == '' ? "disabled" : ""}}
																   data-model-id="{{option.modelId}}"
																   data-org-model-id="{{unit.modelId}}"
																   data-opt-disp-type="B"
																   data-opt-grp-id="{{option.optGrpId}}"
																   data-opt-item-value-id="{{option.optItemValueId}}"
																   data-kiosk-value="{{param.kiosk}}"
															>
															<label for="{{option.optGrpId}}-{{optionGroupIndex}}-{{optionIndex}}"><span>{{#raw option.optItemValueNm}}</span></label>
														</div>
													{{/each}}
												</div>
												<div class="item-middle-prdtype-arrow" style="display: none;">
													<button class="left swiper-button-disabled swiper-button-lock" disabled="" tabindex="-1" aria-label="Previous slide" aria-controls="swiper-wrapper-10dfda605b5e9919f" aria-disabled="true">이전</button>
													<button class="right swiper-button-disabled swiper-button-lock" disabled="" tabindex="-1" aria-label="Next slide" aria-controls="swiper-wrapper-10dfda605b5e9919f" aria-disabled="true">다음</button>
												</div>
												<span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span>
											</div>
										{{#elsif optionGroup.options[optionGroupIndex].optItemAttrCode == "02"}}
											<div class="swiper prd-type-cont2 swiper-initialized swiper-horizontal swiper-pointer-events swiper-backface-hidden">
												<div class="swiper-wrapper" id="swiper-wrapper-f76de7179b091169" aria-live="polite">
													{{#each (option, optionIndex) in optionGroup.options}}
														<div class="swiper-slide chk-wrap-colorchip {{option.optItemValueExtraInfo}} prd-type-radio swiper-slide-active" role="group" aria-label="1 / 2">
															<input type="radio" class="spec_btn" name="{{option.optGrpId}}-{{optionGroupIndex}}" 
																   id="{{option.optGrpId}}-{{optionGroupIndex}}-{{optionIndex}}"
																   {{unit.modelId == option.modelId ? "checked" : ""}}
																   {{unit.modelId == null || unit.modelId == '' ? "disabled" : ""}}
																   data-model-id="{{option.modelId}}"
																   data-org-model-id="{{unit.modelId}}"
																   data-opt-disp-type="B"
																   data-opt-grp-id="{{option.optGrpId}}"
																   data-opt-item-value-id="{{option.optItemValueId}}"
																   data-kiosk-value="{{param.kiosk}}"
																   value="{{option.optItemValueId}}"
															>
															<label for="{{option.optGrpId}}-{{optionGroupIndex}}-{{optionIndex}}"><span>{{#raw option.optItemValueNm}}</span></label>
														</div>
													{{/each}}
												</div>
												<div class="item-middle-prdtype-arrow" style="display: none;">
													<button class="left swiper-button-disabled swiper-button-lock" disabled="" tabindex="-1" aria-label="Previous slide" aria-controls="swiper-wrapper-f76de7179b091169" aria-disabled="true">이전</button>
													<button class="right swiper-button-disabled swiper-button-lock" disabled="" tabindex="-1" aria-label="Next slide" aria-controls="swiper-wrapper-f76de7179b091169" aria-disabled="true">다음</button>
												</div>
												<span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span>
											</div>
										{{/if}}
										{{#if optionGroup.options[optionGroupIndex].optItemAttrCode != "01" && optionGroup.options[optionGroupIndex].optItemAttrCode != "02" && optionGroup.options[optionGroupIndex].optItemAttrCode != "03"}}
											<div class="swiper prd-type-cont1"></div>
										{{/if}}
									{{/each}}
								{{/if}}
							{{/if}}
						{{/if}}
					</div>
				</div>
			
				<div class="item-middle-info">
					<ul class="middle-info-inner">{{# /* 아이템 카드의 크기 보정을 위해 표시할 정보가 없어도 비어있는 middle-info-inner 엘리먼트가 존재해야 함 */ #}}
						{{#if unit.productAttrKeywds != null && unit.productAttrKeywds.length > 0}}
							{{#each prodAttr in unit.productAttrKeywds}}
								{{#if prodAttr.keywds != null && prodAttr.keywds != ""}}
									<li class="middle-info-list">
										<spagroupn class="info">{{#raw prodAttr.attrNm}}</spagroupn>
										{{#each (keywd, index) in prodAttr.keywds.split("^")}}
											<em class="info point {{index+1 == prodAttr.keywds.split("^").length ? "" : "comma"}}">{{#raw keywd}}</em>
										{{/each}}
									</li>
								{{/if}}
							{{/each}}
						{{/if}}
					</ul>
				</div>
				{{# /* 제품 정보 END */ #}}
				
				{{# /* 구매 정보 START */ #}}
				{{#if param.kiosk != "y"}} {{# /* BTOCSITE-58721 */ #}}
					<div class="item-bottom">
						{{#if showPrice == "Y" && member.partnerGrp == "ENT" && logrinFlag == "Y" }}
							<div class="item-bottom-price">
								<div class="item-price-cont normal-price"> {{# /* 아이템 카드의 크기 보정을 위해 표시할 정보가 없어도 비어있는 normal-price 엘리먼트가 존재해야 함 */ #}}
									<div class="item-price-cont-inner">
										<strong class="price"><em>{{vcui.number.addComma(unit.partnerPrice)}}</em>원</strong>
									</div>
								</div>
								{{#if unit.modelStatusCode == "ACTIVE" && unit.couponDiscountPrice > 0 }}
									<div class="item-price-cont max-reward" data-model-url="{{defaultUrl}}{{unit.modelUrlPath}}">
										<span class="reward-text">쿠폰할인가</span>
										<span class="reward-price">{{vcui.number.addComma(unit.partnerPrice-unit.couponDiscountPrice)}}원</span>
									</div>
								{{/if}}
							</div>
						{{#elsif showPrice == "Y"}}
							<div class="item-bottom-price">
								<div class="item-price-cont normal-price">
								</div>
								<div class="item-price-cont max-reward">
								</div>
								<div class="item-price-cont staff-price is-business-price">
									{{# /* BTOCSITE-59035 사업자몰 PLP/PDP 내 사업자회원가 얼럿 내 툴팁 내용 추가 (툴팁 제거, 버튼 추가) */ #}}
									{{# /* 아이템 카드의 크기 보정을 위해 표시할 정보가 없어도 비어있는 staff-price 엘리먼트가 존재해야 함 */ #}}
									<button type="button" class="btn-box" data-member-bsnsMbrStat="{{(member.bsnsMbrStat == "WAIT") ? "W" : "N"}}">사업자회원가 보기</button>
									{{# /* //BTOCSITE-59035 사업자몰 PLP/PDP 내 사업자회원가 얼럿 내 툴팁 내용 추가 */ #}}
								</div>
							</div>
						{{/if}}
				
						{{# /* 내일배송 START */ #}}
						<div class="item-bottom-reward green"> {{# /* 아이템 카드의 크기 보정을 위해 표시할 정보가 없어도 비어있는 item-bottom-reward 엘리먼트가 존재해야 함 */ #}}
							{{#if unit.modelStatusCode == "ACTIVE" && unit.deliveryTomorrowFlag == "Y" && unit.nextDayFlag == "N"}}
								<span>{{unit.deliveryTomorrowText}}</span>
							{{/if}}
						</div>
						<div class="item-bottom-tag"> {{# /* 아이템 카드의 크기 보정을 위해 표시할 정보가 없어도 비어있는 item-bottom-tag 엘리먼트가 존재해야 함 */ #}}
							{{#if unit.modelStatusCode == "ACTIVE" && unit.deliveryTomorrowFlag == "Y" && unit.nextDayFlag == "Y"}}
								<div class="plp-tooltip-item">
									<button type="button" class="tag tomorrow green">내일배송 ~ 15시 주문 시</button>
									<div class="tooltip-box tomorrow">
										<div class="accord-cont ui_accord_content">
											<div class="title">유의사항</div>
											<div class="list">
												<ul>
													<li>제주도/도서산간지역 및 재고 상황에 따라 변동될 수 있습니다.</li>
													<li>일요일/공휴일/물류 휴무일에는 배송이 되지 않습니다.</li>
													<li>지연배송 발생 시 해당일 오전에 지연 안내 문자가 발송됩니다.</li>
													<li>내일배송은 오후 3시 이전 결제 시 가능합니다.</li>
												</ul>
											</div>
										</div>
										<button type="button" class="btn-close"><span class="blind">닫기</span></button>
									</div>
								</div>
							{{/if}}
				
							{{#if showPrice == "Y" && unit.modelStatusCode == "SOLD_OUT"}}
								<em class="badge-sold-out">일시품절</em>
							{{/if}}
						</div>
						{{# /* 내일배송 END */ #}}
				
						{{#if unit.compareAvailYn == "Y"}}
							<div class="item-bottom-bottom">
								<div class="comparison-content">
									<button type="button" class="comparison-content-button"
											data-model-id="{{unit.modelId}}"
											data-model-name="{{#raw unit.modelName}}"
											data-model-display-name="{{#raw unit.modelDisplayName}}"
											data-b2b-cate-mapping="{{unit.b2bCateMapping}}"
											data-care-type="{{unit.careshipOnlyFlag == "Y" && unit.cTypeCount > 0 ? "C" : "R"}}"
											data-default-category-id="{{unit.defaultCategoryId}}"
											data-default-category-name="{{#raw unit.defaultCategoryName}}"
											data-contents="{{#raw unit.modelDisplayName}}"
									>
										비교하기
									</button>
								</div>
							</div>
						{{/if}}
				
					</div>
				{{/if}} {{# /* BTOCSITE-58721 */ #}}
				{{# /* 구매 정보 END */ #}}
			</div>
		`;

		return vcui.template(templateUnit, prdData);
	}

	var getUnitDisposableHtml = function(prdData) {
		return vcui.template(templateUnit, prdData);
	}

	var getUnitCaresolutionHtml = function(prdData) {
		return vcui.template(templateUnit, prdData);
	}

	var templateUnitNoData = `
		<div class="card-list-none">
			<div class="card-list-none-inner">
				<span class="card-list-none-text">
					필터 검색 결과가 없습니다<br />선택한 필터를 변경해보세요.
				</span>
				<button class="card-list-none-button">필터 초기화</button>
			</div>
		</div>	
	`;


});

function goScrollToProductList() { // 제품 리스트로 화면 스크롤 이동하는 이벤트
	
	var offsetPos = $(".base-cate.cate-m").offset();
    if( $(".cate-m.cate-m-tab").is(':visible') ){
        offsetPos = $(".cate-m.cate-m-tab").offset();
    }

	var subRenewMainWrap = $('.subRenewMainWrap');
	var subRenewMainWrapHeader = subRenewMainWrap.find('.header');
    var subRenewWrap = $('.subRenewWrap');
    var subRenewWrapHeader = subRenewWrap.find('.header');
    var subRenewWrapNav = subRenewWrap.find('.sub-renew-nav-wrap');
    var productListTop = subRenewWrap.find('.product-list-top');
    
    //BTOCSITE-61716 모바일 전체 탭 클릭시 앵커 이동안함(카테고리 메뉴가 plp부분을 가리는 현상이 있어서 animate 후에 카테고리 메뉴 hide 함.)
	$('html').animate({scrollTop : offsetPos.top}, 400, function(){
		subRenewMainWrapHeader.addClass('hide');
		subRenewWrapHeader.addClass('hide');
		subRenewWrapNav.addClass('hide');
		productListTop.removeAttr("style");
	});
}

function buildHeadpreloadImage(datas) {
	datas.forEach(d => {
		var element = document.createElement('link');
		element.rel = 'preload';
		element.as = 'image';
		element.href = d;
		document.head.appendChild(element);
	});
}

$(function() {
	var bizType = $('.hidden-input-group input[name=bizType]').val();
	//var subCategoryId = $('.hidden-input-group input[name=subCategoryId]').val();
	var lineupId = $('.hidden-input-group input[name=lineupId]').val();
	//BTOCSITE-61716 모바일 전체 탭 클릭시 앵커 이동안함(subCategoryId가 ''일때도 앵커이동하도록 변경하니 노트북 하위 뎁스에서도 엥커 이동해서 lineupId가 있을때는 앵커 이동 안하도록 함.) 
	//if ((bizType === 'PRODUCT' || bizType === 'CARESOLUTION') && subCategoryId !== '') {
	if ((bizType === 'PRODUCT' || bizType === 'CARESOLUTION') && lineupId == '') {	
		//PLP 진입 시 자동 스크롤 기능 제거
		//goScrollToProductList();
	}
});
/* BTOCSITE-40437 PLP 스크립트 end */


//s:BTOCSITE-60383 [구독 Task] 구독 유입경로 강화 - 일시불 PLP - 스크롤 이벤트 추가
var isCareSolBannerVisible = false;
function checkCareSolBannerVisible() {
	var viewportHeight = $(window).height();
	var scrollTop = $(window).scrollTop();

	if (!$('.gtwy-caresolution').eq(0).length) return;
	var y = $('.gtwy-caresolution').eq(0).offset().top;
	var elementHeight = $('.gtwy-caresolution').eq(0).height();

	return ((y+elementHeight < (viewportHeight + scrollTop)) && (y >scrollTop));
}

function fnCheckCareSolBannerVisible() {
	if(!isCareSolBannerVisible && checkCareSolBannerVisible()){
		if (typeof dataLayer !== 'undefined' && dataLayer) {

			const careBannerData = {
				'event' : 'customEvent',
				'ga4event' : 'banner_impression',
				'customEventCategory': '배너노출',
				'customEventAction': '배너노출 - PLP 가전구독'
			}

			fnDataLayeryPush(careBannerData);
			isCareSolBannerVisible = true;
		}
	}

	isCareSolBannerVisible && window.removeEventListener('scroll',fnCheckCareSolBannerVisible);
}

function fnDataLayeryPush(data){ // 해당 페이지 공틍 사용 분리
	dataLayer.push(data);
}

window.addEventListener('scroll', fnCheckCareSolBannerVisible);
//e:BTOCSITE-60383 [구독 Task] 구독 유입경로 강화 - 일시불 PLP - 스크롤 이벤트 추가